var _path, _rect, _rect2, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M708.12,459.44c0,.14-149.15.26-333.1.26s-333.14-.12-333.14-.26S191,459.18,375,459.18,708.12,459.3,708.12,459.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.77,443c.59-2.27-.9-4.54-2.56-6.19s-3.66-3.11-4.53-5.29c-1.4-3.52.49-8.08-1.91-11-1.41-1.73-3.93-2.31-5.18-4.15a9.44,9.44,0,0,1-1.13-3.3,33.57,33.57,0,0,0-8.34-15.6,29.15,29.15,0,0,0,3.27,15c1,1.85,2.17,3.65,2.49,5.71.52,3.35-1.35,6.8-.53,10.09.94,3.76,5.17,6.27,5.37,10.14.17,3.28-2.69,6.15-2.47,9.42a8.83,8.83,0,0,0,1.45,3.88c2.53,4.2,6.25,7.1,11.88,7l6.9.24Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.77,443c.59-2.27-.9-4.54-2.56-6.19s-3.66-3.11-4.53-5.29c-1.4-3.52.49-8.08-1.91-11-1.41-1.73-3.93-2.31-5.18-4.15a9.44,9.44,0,0,1-1.13-3.3,33.57,33.57,0,0,0-8.34-15.6,29.15,29.15,0,0,0,3.27,15c1,1.85,2.17,3.65,2.49,5.71.52,3.35-1.35,6.8-.53,10.09.94,3.76,5.17,6.27,5.37,10.14.17,3.28-2.69,6.15-2.47,9.42a8.83,8.83,0,0,0,1.45,3.88c2.53,4.2,6.25,7.1,11.88,7l6.9.24Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.88,459.15a5.63,5.63,0,0,0,1.9,0,11.49,11.49,0,0,0,2.24-.57,9.56,9.56,0,0,0,2.77-1.51,3.91,3.91,0,0,0,1.14-1.52,6.94,6.94,0,0,0,.32-2.06,21.86,21.86,0,0,1,.16-2.24,6.21,6.21,0,0,1,.85-2.21c.81-1.43,2.16-2.79,2.6-4.73a15.66,15.66,0,0,0-.19-6,12.89,12.89,0,0,1,.16-6.49c.74-2.15,2.25-4.1,3-6.53s.4-5.1.56-7.71a10.42,10.42,0,0,1,.9-3.83c.56-1.22,1.33-2.37,1.94-3.66,1.22-2.6,1.44-5.55,1.77-8.43.17-1.46.33-2.93.5-4.41a21.22,21.22,0,0,1,.77-4.41,37.18,37.18,0,0,1,1.65-4.27,15.91,15.91,0,0,0,.8-2.23c.13-.82.17-1.58.22-2.38a28.24,28.24,0,0,0-.18-4.77c-.19-1.59-.48-3.17-.65-4.77l0-.27,0-.32-.28.14a10.62,10.62,0,0,0-3.71,3.13,17.24,17.24,0,0,0-2.29,4.21,51.86,51.86,0,0,0-2.14,9,24.57,24.57,0,0,1-2.84,8.35c-.75,1.23-1.67,2.35-2.47,3.55a9.74,9.74,0,0,0-1.71,3.93c-.41,2.92,1.2,5.48.86,8.07a9,9,0,0,1-1.26,3.58c-.62,1.1-1.36,2.12-2.06,3.15a20.39,20.39,0,0,0-1.85,3.18,10.16,10.16,0,0,0-.85,3.46c-.17,2.33.16,4.54,0,6.62a15.19,15.19,0,0,1-1.7,5.67c-.83,1.7-1.76,3.23-2.54,4.72a24.12,24.12,0,0,0-1,2.2,10.2,10.2,0,0,0-.61,2.18,13.78,13.78,0,0,0,0,3.94,9.92,9.92,0,0,0,2,5,4.94,4.94,0,0,0,.56.61,2.75,2.75,0,0,0,.45.38l.4.28a8.92,8.92,0,0,1-1.34-1.32,10,10,0,0,1-1.87-5,13.45,13.45,0,0,1,.09-3.88,10,10,0,0,1,.61-2.13,23.83,23.83,0,0,1,1-2.17c.78-1.48,1.72-3,2.57-4.71a15.53,15.53,0,0,0,1.77-5.77c.18-2.13-.14-4.35,0-6.62a9.61,9.61,0,0,1,.84-3.34,19.1,19.1,0,0,1,1.83-3.12c.69-1,1.44-2.05,2.08-3.17a9.26,9.26,0,0,0,1.32-3.73c.33-2.76-1.26-5.34-.85-8.05a9.37,9.37,0,0,1,1.66-3.76c.78-1.18,1.7-2.3,2.48-3.56a24.8,24.8,0,0,0,2.9-8.48,51,51,0,0,1,2.14-9,16.13,16.13,0,0,1,2.22-4.1,10.12,10.12,0,0,1,3.56-3l-.32-.18,0,.28c.17,1.61.46,3.2.65,4.77a28.47,28.47,0,0,1,.18,4.7c-.05.77-.09,1.58-.21,2.3a13.64,13.64,0,0,1-.78,2.16,38.72,38.72,0,0,0-1.66,4.31,21.9,21.9,0,0,0-.78,4.49c-.16,1.48-.32,2.95-.49,4.41-.33,2.9-.54,5.8-1.72,8.31-.58,1.25-1.36,2.4-1.93,3.66a10.52,10.52,0,0,0-.93,4c-.15,2.66.2,5.26-.52,7.62s-2.22,4.31-3,6.53a13,13,0,0,0-.15,6.64,15.41,15.41,0,0,1,.22,5.94c-.4,1.85-1.71,3.19-2.54,4.66a6.35,6.35,0,0,0-.85,2.31,19.93,19.93,0,0,0-.15,2.26,6.66,6.66,0,0,1-.29,2,3.67,3.67,0,0,1-1.07,1.45,9.26,9.26,0,0,1-2.71,1.53,11.43,11.43,0,0,1-2.21.6,7.78,7.78,0,0,1-1.4.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.68,377.86a.8.8,0,0,0-.07.21l-.15.62c-.14.55-.3,1.37-.56,2.39s-.89,2.18-1.43,3.61a50.64,50.64,0,0,0-1.64,4.89c-.53,1.84-1,3.88-1.48,6.07a25.56,25.56,0,0,1-2.21,6.74c-.56,1.12-1.2,2.26-1.71,3.5a16.42,16.42,0,0,0-1,4,77.91,77.91,0,0,1-1.49,8.34c-1.38,5.66-2.7,11-3.9,15.95s-2.34,9.29-3.27,13l-2.17,8.78c-.24,1-.43,1.81-.56,2.39-.06.25-.1.46-.14.62a.61.61,0,0,0,0,.22.8.8,0,0,0,.07-.21c0-.16.11-.36.18-.61.16-.58.38-1.37.65-2.37.56-2.1,1.34-5.08,2.31-8.74s2.09-8.1,3.36-13S106,424,107.38,418.29a76.58,76.58,0,0,0,1.49-8.38,15.71,15.71,0,0,1,1-3.86c.48-1.21,1.11-2.34,1.68-3.47a25.83,25.83,0,0,0,2.2-6.85c.47-2.19.92-4.23,1.42-6.06s1-3.48,1.57-4.89,1.11-2.59,1.37-3.65.37-1.86.48-2.42l.11-.63A.72.72,0,0,0,118.68,377.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1,459.17c4.5-2.68,5.8-10.81,3.92-15.7s-5.17-9.37-5.68-14.59c-.39-4,.92-8.13,0-12.05C95.07,411.54,89.9,407.44,90,402c0-3.06,1.77-5.93,1.63-9-.17-3.74-3-6.7-4.81-10-2.73-5-2.9-11-3.84-16.65s-3.08-11.71-8.09-14.49c-.74,4.8-2,8.09-1.61,14.59.15,2.33,2.86,6.81,3.23,11.92.22,3.06.37,6.13.56,9.19a29.33,29.33,0,0,0,1.44,8.8c.82,2.13,2.13,4.07,2.74,6.28,1.14,4.14-.36,8.64.56,12.84.79,3.56,3.25,6.62,3.75,10.24.71,5.07-2.57,10.34-.89,15.18.83,2.4,2.81,4.33,3.37,6.81.43,1.92,0,4,.35,5.89.64,3.11,6.58,5.53,9.75,5.34",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.09,356.65a1.17,1.17,0,0,0,0,.28c0,.2.06.46.1.78.11.7.22,1.72.46,3s.93,2.82,1.48,4.61,1.14,3.86,1.65,6.17.94,4.87,1.39,7.63a32.36,32.36,0,0,0,2.31,8.62c.64,1.44,1.35,2.88,1.88,4.42a20.41,20.41,0,0,1,1,4.87,96.55,96.55,0,0,0,1.32,10.5c1.38,7.11,2.7,13.88,3.89,20.05s2.4,11.67,3.36,16.33,1.75,8.38,2.3,11c.27,1.28.49,2.28.64,3q.12.48.18.78a.91.91,0,0,0,.08.26s0-.1,0-.27-.08-.46-.14-.79c-.13-.71-.32-1.72-.57-3-.51-2.63-1.25-6.39-2.16-11s-2-10.2-3.26-16.35-2.49-12.94-3.85-20A98.12,98.12,0,0,1,86.76,397a20.56,20.56,0,0,0-1-5c-.55-1.57-1.27-3-1.9-4.44a31.62,31.62,0,0,1-2.32-8.52c-.47-2.75-.92-5.32-1.46-7.64a63,63,0,0,0-1.72-6.17c-.57-1.81-1.27-3.28-1.54-4.57s-.41-2.32-.54-3c-.06-.32-.11-.58-.14-.78A1.23,1.23,0,0,0,76.09,356.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.48,140.08a3.26,3.26,0,0,1,0,.39c0,.29,0,.65,0,1.09,0,1,0,2.37.06,4.09,0,3.53.06,8.49.11,14.42l-.22-.23,20,0-.26.26h0v-5.37c0-1.77,0-3.49,0-5.17,0-3.36,0-6.52,0-9.43l.23.22-14.42-.11-4.09-.06-1.09,0-.39,0a1.34,1.34,0,0,1,.34,0l1,0,4-.06,14.57-.12h.22v.23c0,2.91,0,6.07,0,9.43,0,1.68,0,3.4,0,5.17v5.37h0l-.26.26-20,0h-.23v-.22c0-6,.09-11,.12-14.57,0-1.69,0-3.05.06-4,0-.43,0-.77,0-1.05A1.25,1.25,0,0,1,586.48,140.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.64,135.61c.33.28-4,6.06-9.6,12.92l-3.37,4-.5.59-.56-.5c-4.7-4.2-7.91-7.36-7.69-7.62s3.82,2.47,8.66,6.51l-1.05.09,3.31-4.1C605.47,140.68,610.31,135.34,610.64,135.61Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.87,119.75a3.8,3.8,0,0,1,.5,0l1.46.05c.32,0,.68,0,1.08,0l1.29.19,1.51.21,1.68.42a27.28,27.28,0,0,1,8.16,3.56,29.19,29.19,0,0,1,8.44,8.22,29.57,29.57,0,0,1,4.79,13.42,30.34,30.34,0,0,1,.08,3.94c-.05.67,0,1.35-.13,2s-.21,1.35-.31,2a28.82,28.82,0,0,1-2.74,8,30.83,30.83,0,0,1-5.25,7.22,30.34,30.34,0,0,1-7.55,5.43,27.35,27.35,0,0,1-9.21,2.82,18.28,18.28,0,0,1-2.46.21,20.49,20.49,0,0,1-2.48,0,29.9,29.9,0,0,1-5-.63,29.06,29.06,0,0,1-9.91-4.17l.3,0-10.08,4-.6.24.17-.62,3-10.78,0,.27a28.9,28.9,0,0,1-5.38-12.33,26,26,0,0,1-.4-6.31,21.6,21.6,0,0,1,.29-3c.08-.49.15-1,.23-1.48s.24-1,.35-1.42A28.87,28.87,0,0,1,579,125a27.77,27.77,0,0,1,6.7-3.53l1.51-.54,1.43-.36,1.31-.33c.42-.08.83-.12,1.21-.18.76-.1,1.43-.23,2-.26l1.48,0,.9,0a1.43,1.43,0,0,1,.31,0,.92.92,0,0,1-.31,0l-.9.08-1.47.1c-.58,0-1.25.19-2,.3a28.68,28.68,0,0,0-22.93,21.27c-.11.47-.26.93-.34,1.41s-.15,1-.22,1.45a19.4,19.4,0,0,0-.27,3,26,26,0,0,0,.41,6.19,28.48,28.48,0,0,0,5.31,12.06l.09.12,0,.14-2.94,10.79-.43-.38,10.08-4.06.16-.06.14.09a28.56,28.56,0,0,0,9.68,4.07,29.78,29.78,0,0,0,4.86.62c.82,0,1.63,0,2.43,0a17.27,17.27,0,0,0,2.4-.2,26.85,26.85,0,0,0,9-2.76,29.65,29.65,0,0,0,7.4-5.29,30.19,30.19,0,0,0,5.15-7.05,28.44,28.44,0,0,0,2.71-7.86c.11-.67.21-1.33.31-2s.09-1.33.14-2a28.41,28.41,0,0,0-12.95-25.26,27.51,27.51,0,0,0-8-3.61l-1.67-.45-1.49-.24-1.28-.21c-.39,0-.75-.06-1.07-.08l-1.45-.11A3.3,3.3,0,0,1,595.87,119.75Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.18,380.42a32.21,32.21,0,0,1-6.95-4.89l-7.41,2.64-7-11,5.55-5.58a32.07,32.07,0,0,1-1.45-8.37l-7.11-3.37,2.85-12.71,7.87,0a31.57,31.57,0,0,1,4.89-6.94l-2.64-7.42,11-7,5.58,5.56a31.66,31.66,0,0,1,8.36-1.46l3.38-7.11,12.71,2.85,0,7.87a32.15,32.15,0,0,1,6.94,4.89l7.41-2.64,7,11-5.56,5.58a32.5,32.5,0,0,1,1.46,8.37l7.1,3.37-2.85,12.71-7.87,0a31.57,31.57,0,0,1-4.89,6.94l2.64,7.42-11,7-5.58-5.56a31.66,31.66,0,0,1-8.36,1.46l-3.38,7.11-12.71-2.85v-7.87Zm11.2-15a14,14,0,1,0-10.57-16.69A14,14,0,0,0,572.38,365.46Z",
    style: {
      fill: "#1EB445",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.06,343.25a6,6,0,0,1-1.91-.6,8.2,8.2,0,0,1-4.6-7.6,8.31,8.31,0,0,1,1.28-4.19,7.85,7.85,0,0,1,1.56-1.81,8.06,8.06,0,0,1,2.11-1.34,8.26,8.26,0,0,1,9.61,2.16,7.61,7.61,0,0,1,1.34,2.11,7.74,7.74,0,0,1,.63,2.3,8.32,8.32,0,0,1-.62,4.34,8.19,8.19,0,0,1-2.3,3,8,8,0,0,1-5.11,1.86,6.31,6.31,0,0,1-2-.27c0-.06.71.14,2,.09a8,8,0,0,0,7.61-9,8,8,0,0,0-1.89-4.17,7.87,7.87,0,0,0-9.09-2,7.13,7.13,0,0,0-2,1.26,7.71,7.71,0,0,0-1.49,1.7,8.09,8.09,0,0,0-1.26,4,8,8,0,0,0,.7,3.59,8.1,8.1,0,0,0,3.6,3.84C650.36,343.07,651.08,343.19,651.06,343.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.56,351.92a1.64,1.64,0,0,1,0,.29c0,.21,0,.49,0,.86,0,.8,0,1.94,0,3.42l-.06-.07L652,358l-.13.06,1.94-4.13,0-.07h.08a18.47,18.47,0,0,0,4.81-.85l.09,0,.07.07,3.24,3.21-.2,0,6.37-4.06-.08.21c-.47-1.33-1-2.79-1.54-4.29l0-.11.08-.09a18.06,18.06,0,0,0,2.8-4l.06-.11h4.69L674,344c.52-2.32,1.08-4.82,1.65-7.38l.12.25-4.13-2-.12-.06v-.13a18.5,18.5,0,0,0-.84-4.79l0-.13.09-.1,3.22-3.24,0,.28-4-6.38.27.1-4.3,1.53-.14.05-.1-.1a18.35,18.35,0,0,0-4-2.8h0c-.06-.09.12.21-.13-.21h0v-4.55l.18.23-7.37-1.66.26-.13c-.66,1.39-1.32,2.77-2,4.13l-.06.12h-.14a18.36,18.36,0,0,0-4.8.83l-.13,0-.09-.1-3.24-3.22.28,0-6.39,4,.09-.26,1.53,4.31,0,.12-.09.09a18.56,18.56,0,0,0-2.81,4l-.06.11H632.1l.19-.15c-.59,2.59-1.15,5-1.67,7.37l-.1-.2,4.12,2,.09,0v.1a18.52,18.52,0,0,0,.83,4.81l0,.09-.07.07-3.23,3.22,0-.17,4,6.4-.12,0,4.31-1.5,0,0,0,0a18.77,18.77,0,0,0,2.93,2.26l.78.47.26.16-.27-.12c-.19-.09-.46-.23-.81-.44a17.32,17.32,0,0,1-3-2.22l.07,0-4.29,1.56-.08,0,0-.08c-1.16-1.79-2.5-3.89-4.08-6.36l-.06-.09.08-.08,3.21-3.25,0,.16a18.24,18.24,0,0,1-.87-4.9l.09.15-4.12-1.95-.13-.06,0-.14,1.64-7.38,0-.15h.16l4.56,0-.18.11a18.68,18.68,0,0,1,2.87-4.07l-.05.21-1.53-4.3-.06-.16.14-.1c2.08-1.31,4.2-2.66,6.38-4.05l.15-.09.13.12c1.06,1.06,2.14,2.14,3.24,3.22l-.23-.05a18.73,18.73,0,0,1,4.91-.86l-.2.13,2-4.12.08-.17.18,0,7.37,1.65.18,0v.19c0,.75,0,1.51,0,2.27v2.28h0c-.25-.41-.06-.11-.12-.2h0a19,19,0,0,1,4.08,2.87l-.24-.05L670,320l.18-.06.1.16,4,6.38.1.15-.13.13L671.09,330l.06-.23a19,19,0,0,1,.85,4.91l-.13-.19,4.12,2,.16.08,0,.17c-.58,2.56-1.14,5.05-1.66,7.37l0,.16h-4.73l.18-.1a19.11,19.11,0,0,1-2.87,4.06l0-.19,1.52,4.3.05.14-.13.08-6.39,4-.11.07-.09-.1-3.23-3.23.15,0a18.94,18.94,0,0,1-4.89.84l.12-.08-2,4.11,0,.09-.09,0-7.36-1.7h-.06v-.06q0-2.21,0-3.39c0-.37,0-.66,0-.87S644.56,351.93,644.56,351.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608,308.43a15.82,15.82,0,0,1-3.44-2.43l-3.68,1.31-3.46-5.46,2.76-2.77a16,16,0,0,1-.73-4.15l-3.52-1.67,1.41-6.31h3.9a15.65,15.65,0,0,1,2.43-3.45l-1.31-3.68,5.46-3.46,2.77,2.76a15.57,15.57,0,0,1,4.15-.72l1.67-3.53,6.31,1.41v3.91a15.89,15.89,0,0,1,3.45,2.43l3.68-1.31,3.46,5.45-2.76,2.77a15.57,15.57,0,0,1,.72,4.15l3.53,1.68-1.42,6.3h-3.9a15.82,15.82,0,0,1-2.43,3.44l1.31,3.68-5.45,3.46-2.77-2.76a16,16,0,0,1-4.15.73l-1.68,3.52-6.3-1.41v-3.9Zm5.56-7.42a6.93,6.93,0,1,0-5.25-8.28A6.94,6.94,0,0,0,613.55,301Z",
    style: {
      fill: "#1EB445",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M608,308.43a15.82,15.82,0,0,1-3.44-2.43l-3.68,1.31-3.46-5.46,2.76-2.77a16,16,0,0,1-.73-4.15l-3.52-1.67,1.41-6.31h3.9a15.65,15.65,0,0,1,2.43-3.45l-1.31-3.68,5.46-3.46,2.77,2.76a15.57,15.57,0,0,1,4.15-.72l1.67-3.53,6.31,1.41v3.91a15.89,15.89,0,0,1,3.45,2.43l3.68-1.31,3.46,5.45-2.76,2.77a15.57,15.57,0,0,1,.72,4.15l3.53,1.68-1.42,6.3h-3.9a15.82,15.82,0,0,1-2.43,3.44l1.31,3.68-5.45,3.46-2.77-2.76a16,16,0,0,1-4.15.73l-1.68,3.52-6.3-1.41v-3.9Zm5.56-7.42a6.93,6.93,0,1,0-5.25-8.28A6.94,6.94,0,0,0,613.55,301Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,134.56a14.63,14.63,0,0,1-3.85.1l-2,3L233,135.5l.52-3.54a13.72,13.72,0,0,1-2.79-2.65l-3.51.69-2.39-5.4,2.86-2.13a14.63,14.63,0,0,1-.09-3.85l-3-2,2.13-5.51,3.53.52a14.29,14.29,0,0,1,2.65-2.79l-.69-3.51,5.4-2.39,2.13,2.86a14.64,14.64,0,0,1,3.85-.09l2-3,5.51,2.13-.51,3.53a14.88,14.88,0,0,1,2.79,2.65l3.5-.69,2.39,5.4-2.86,2.13a14.64,14.64,0,0,1,.1,3.85l3,2-2.12,5.51-3.54-.51a14.26,14.26,0,0,1-2.65,2.79l.69,3.5-5.4,2.39-2.13-2.86Zm0-8.47a6.34,6.34,0,1,0-8.36-3.23A6.34,6.34,0,0,0,244.38,126.09Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,126.09a1.25,1.25,0,0,1-.36.19,4.65,4.65,0,0,1-1.12.35,6.29,6.29,0,0,1-4.23-.63,6.55,6.55,0,1,1,9.48-4.2,6.36,6.36,0,0,1-2.37,3.56,5.43,5.43,0,0,1-1,.59,1.39,1.39,0,0,1-.39.14s.5-.26,1.27-.89a6.29,6.29,0,0,0,2.14-3.49,6.14,6.14,0,0,0-1.59-5.63,6,6,0,0,0-3.09-1.72,6.07,6.07,0,0,0-6.57,2.92,6,6,0,0,0-.8,3.44,6.16,6.16,0,0,0,3.11,5,6.26,6.26,0,0,0,4,.75C243.85,126.28,244.36,126,244.38,126.09Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,134.56l.15.17.41.52,1.64,2.12-.1,0,5.38-2.44-.08.14c-.21-1.06-.45-2.23-.71-3.49l0-.09.07-.06a14.8,14.8,0,0,0,2.62-2.77l.06-.09.1,0,3.53.5-.2.12c.67-1.74,1.37-3.59,2.11-5.52l.08.24-3-2-.11-.07v-.13a14.3,14.3,0,0,0-.1-3.79l0-.14.11-.08,2.85-2.14-.07.29c-.75-1.7-1.57-3.53-2.4-5.4l.26.14-3.5.69-.14,0-.1-.11a14.24,14.24,0,0,0-2.74-2.61l-.12-.09,0-.15c.16-1.1.33-2.31.51-3.53l.16.27L245.52,103l.31-.09-2,3-.09.13h-.16a13.69,13.69,0,0,0-3.77.09h0l-.25-.1h0l0,0,0,0-.07-.09-.13-.18-.27-.36-.53-.72-1.07-1.43.32.09-5.4,2.39.14-.29q.36,1.77.69,3.51l0,.15-.12.1a14.34,14.34,0,0,0-2.61,2.73l-.09.13-.15,0-3.53-.52.27-.16-2.13,5.51-.09-.29,3,2,.11.08v.14a14.45,14.45,0,0,0,.08,3.78l0,.14-.1.08L225,124.78l.07-.27c.83,1.91,1.62,3.7,2.38,5.41l-.22-.11,3.5-.68.11,0,.07.08a14.48,14.48,0,0,0,2.75,2.64l.08.06v.1c-.2,1.28-.37,2.44-.54,3.53l-.09-.17,5.49,2.16-.13.05,2-2.95,0,0h.05a15.56,15.56,0,0,0,2.89.07l.71-.06.24,0-.23.06c-.16,0-.39.07-.71.1a13.52,13.52,0,0,1-2.92,0l.08,0-2,3,0,.07-.09,0-5.52-2.09-.12,0,0-.13c.15-1.09.32-2.25.5-3.53l.07.16a14.45,14.45,0,0,1-2.84-2.67l.18.06-3.5.71-.15,0-.07-.15-2.41-5.39-.07-.16.14-.1,2.86-2.14-.09.22a14.25,14.25,0,0,1-.1-3.92l.1.22-3-2-.16-.11.07-.17,2.11-5.52.07-.18.2,0,3.53.51-.24.1a14.8,14.8,0,0,1,2.7-2.84l-.09.25q-.35-1.74-.69-3.51l0-.2.19-.08,5.4-2.4.19-.08.12.16,1.06,1.43.54.72.27.36.13.18.07.09,0,0,0,0h0c-.5-.21-.14-.06-.25-.11h0a14.71,14.71,0,0,1,3.91-.09l-.24.11,2-3,.11-.17.19.07,5.51,2.13.2.07,0,.2c-.18,1.22-.36,2.43-.52,3.54l-.11-.25a14.71,14.71,0,0,1,2.84,2.71l-.24-.09,3.5-.69.19,0,.08.17,2.39,5.41.07.17-.15.11-2.86,2.12.08-.21a14.35,14.35,0,0,1,.09,3.91l-.09-.21,3,2,.13.09-.06.16c-.75,1.93-1.46,3.77-2.14,5.5l-.05.14-.15,0-3.53-.53.16-.07a14.75,14.75,0,0,1-2.69,2.81l.05-.15c.24,1.26.47,2.44.67,3.5l0,.11-.1,0-5.41,2.35-.07,0,0-.06-1.55-2.14-.39-.56A1.21,1.21,0,0,1,244.34,134.56Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.38,126.09l-.18.07a5,5,0,0,1-.56.19,5.92,5.92,0,0,1-2.26.26,6.36,6.36,0,1,1,2.18-12.47,6.46,6.46,0,0,1,3.1,2,6.44,6.44,0,0,1,.79,7.39,6.84,6.84,0,0,1-1.26,1.63,6.15,6.15,0,0,1-.81.64l-.44.29-.22.13-.11.06-.05,0h0l0,0a.26.26,0,0,0,0-.28l-.3-.13a4.08,4.08,0,0,0,.74-.35,6.16,6.16,0,0,0,2.83-6.62,6.27,6.27,0,0,0-12.28,2.56,6.36,6.36,0,0,0,5.76,5.18,6.46,6.46,0,0,0,2.26-.25c.51-.15.75-.29.76-.27a2.28,2.28,0,0,1-.72.37,5.84,5.84,0,0,1-2.31.35,6.52,6.52,0,0,1-3.49-1.21,6.63,6.63,0,0,1-2.62-4.1,6.71,6.71,0,1,1,10.08,4.44,4.3,4.3,0,0,1-.87.4l-.2.06-.1-.19a.3.3,0,0,1,0-.31l.05-.05,0,0,.06,0,.11-.07.21-.12.41-.26a7.58,7.58,0,0,0,.75-.6,6,6,0,0,0,1.16-1.5,6,6,0,0,0-3.56-8.64,6,6,0,0,0-5.87,1.55,6.05,6.05,0,0,0-1.66,5.11,6.12,6.12,0,0,0,2.28,3.88,6.4,6.4,0,0,0,5.43,1.11C244.11,126.14,244.37,126,244.38,126.09Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.34,134.56l2.16,2.9-.07,0,5.51-2.44-.06.1c-.21-1.08-.45-2.28-.7-3.57h.21l0,.11-.17-.13a14.18,14.18,0,0,0,2.65-2.79l.15.19-.11.05,0-.24,3.63.53-.15.09,2.21-5.72.05.18-3.06-2,.23-.2.07.14-.3,0a14.71,14.71,0,0,0-.1-3.84l.32,0-.06.15-.26-.2,3-2.21-.06.22-2.5-5.64.2.1-3.63.72,0-.37.17.06-.22.31a14.19,14.19,0,0,0-2.79-2.65l.31-.24.07.17-.39,0c.16-1.11.35-2.38.54-3.67l.13.22-5.79-2.22.26-.08-2.07,3.09-.27-.32.17-.08.07.42a14.68,14.68,0,0,0-3.84.09h0l0-.43h0l-.17.42h0s0,0,0,0h.09l.14-.39,0,0h0l.06,0,.12,0-.26.35-2.22-3,.27.07-5.66,2.52.14-.26.72,3.64-.46,0,.07-.17.37.26a14.65,14.65,0,0,0-2.64,2.78l-.29-.36.17-.07.06.46-3.67-.53.26-.15c-.69,1.79-1.44,3.77-2.21,5.77l-.09-.3,3.08,2.06-.37.31-.07-.15.47-.08a15,15,0,0,0,.1,3.82l-.48,0,.06-.15.39.3-3,2.21.08-.31c.79,1.75,1.64,3.67,2.51,5.61l-.29-.15,3.61-.72,0,.49-.12-.05.28-.4a14.84,14.84,0,0,0,2.78,2.62l-.39.31,0-.11.49-.07c-.16,1.14-.33,2.38-.51,3.62l-.17-.28,5.67,2.16-.31.1c.63-1,1.31-2,2-3l.33.37-.06,0-.08-.49a13.34,13.34,0,0,0,3.27-.07l.27,0s0,0,0,0a.08.08,0,0,0,0,0l0,0h0c-.08,0,0,.39.14.34h.09l-.55.05c-.36,0-.74.07-1.12.08a15.07,15.07,0,0,1-2.23-.1l.25-.11-2,3-.29-.39.09,0v.49l-5.5-2.15.31-.37.07.11-.48.09.54-3.6.1.25a14.53,14.53,0,0,1-2.91-2.79l.25.09-3.58.7.07-.48.15.08-.35.33q-1.22-2.73-2.38-5.41l.47,0,0,.18-.4-.27,2.94-2.18-.1.24a14.62,14.62,0,0,1-.09-4.07l.11.24-3-2,.37-.28.06.2-.46,0,2.13-5.5.35.29-.19.11-.08-.45,3.63.54-.23.09a14.65,14.65,0,0,1,2.82-3l-.08.23c-.25-1.23-.48-2.42-.71-3.6l.44.06-.11.2-.3-.33,5.4-2.38,0,.43-.22-.06.24-.36c.73,1,1.44,1.93,2.13,2.87l-.1-.08.12.05.06,0h0l-.25.13.09.28h0l.16-.42h-.1a14.41,14.41,0,0,1,4-.08l-.21.1,2.05-3.06.25.33-.22.06v-.4l5.51,2.13-.25.3-.11-.2.38-.07c-.19,1.29-.36,2.47-.53,3.64l-.08-.19a14.57,14.57,0,0,1,2.94,2.8l-.19-.07,3.6-.71-.05.35-.18-.09.26-.25c.85,1.94,1.63,3.71,2.39,5.4l-.34,0,.06-.19.27.18L256.36,118l.07-.16a14.53,14.53,0,0,1,.1,4l-.07-.15c1.14.77,2.1,1.42,3,2l-.23.18-.06-.17h.29l-2.13,5.51-.19-.16.14-.08.05.25-3.61-.53.12,0a14.56,14.56,0,0,1-2.75,2.89l0-.11c.29,1.49.51,2.57.7,3.57l-.17,0,.05-.1.12.13-5.4,2.39v-.11l.07,0-.06.09-2.13-2.86a6.35,6.35,0,0,1,.57.67l1.65,2.12.11.13-.17,0h-.07l-.15,0,.15-.07,5.37-2.46.24-.11-.12.24-.06.1-.12.23-.05-.26c-.2-1-.43-2.07-.73-3.55l0-.07.06,0a14.75,14.75,0,0,0,2.68-2.86l0-.06h.08l3.6.5.38.06-.33.19-.14.08-.32.19.13-.35c.63-1.66,1.3-3.43,2.1-5.52l.15-.41.13.41.06.17.13.41-.36-.23-3.05-2-.08,0v-.1a14,14,0,0,0-.12-4v-.1l.08-.06,2.93-2.2.4-.3-.12.49-.05.19-.13.49-.21-.46c-.75-1.7-1.54-3.46-2.41-5.39l-.22-.49.48.24.19.1.47.25-.52.1-3.6.72-.12,0-.07-.1a14.43,14.43,0,0,0-2.88-2.72l-.1-.07,0-.12c.17-1.17.34-2.35.52-3.64l.09-.58.3.51.11.19.3.51-.56-.21-5.51-2.12-.57-.22.58-.19.22-.06.58-.19-.34.51-2,3.06-.08.11h-.13a14.16,14.16,0,0,0-3.84.08h-.08l-.05,0h0l0-.11v0l.08-.21c0-.1,0-.07,0-.07h.06l.09.29-.24.13h-.06l-.06,0-.12-.05-.06,0,0,0-2.14-2.86-.39-.52.63.17.22,0,.63.17-.59.26-5.4,2.4-.61.28.31-.6.1-.2.31-.59.13.65c.23,1.19.47,2.38.71,3.61l0,.14-.11.09a14.34,14.34,0,0,0-2.73,2.87l-.08.12-.15,0-3.63-.53-.69-.1.6-.35.18-.11.61-.35-.26.65q-1,2.72-2.12,5.51l-.25.66-.22-.67-.06-.2-.22-.68.59.4,3.05,2,.13.09,0,.15a14,14,0,0,0,.09,3.93l0,.15-.13.09-2.94,2.19-.58.43.18-.7.05-.18.19-.71.29.67c.79,1.78,1.58,3.58,2.39,5.4l.29.67-.65-.34-.15-.08-.65-.34.72-.14,3.58-.7.15,0,.1.12a14.4,14.4,0,0,0,2.82,2.69l.12.09,0,.16-.54,3.6-.11.73-.37-.64-.06-.11-.38-.65.69.28,5.51,2.14.68.27-.7.22-.1,0-.71.23.42-.62c.67-1,1.34-2,2-3l.09-.13.15,0a15.48,15.48,0,0,0,2.16.09c.36,0,.72,0,1.08-.07l.57-.06h.14c.09,0,.22.36.14.35h0l0,0-.12.07a.73.73,0,0,1-.26.09l-.28,0a13.42,13.42,0,0,1-3.4.06l-1-.09.86-.4.06,0,.83-.39-.5.77-2,3-.11.18-.2-.08-5.66-2.15-.19-.07,0-.21c.17-1.24.35-2.48.51-3.62l.13-.92.37.86,0,.11.36.85-.74-.54a15,15,0,0,1-2.88-2.72l-.58-.72.87.32.13,0,.86.31-.9.18-3.61.72-.2,0-.08-.19-2.5-5.6-.08-.19.16-.12,3-2.21.72-.54-.34.84-.06.15-.34.83-.14-.89a14.65,14.65,0,0,1-.1-4l.09-.9.38.82.07.15.38.81-.74-.5-3.08-2.06-.17-.11.08-.18,2.22-5.77.07-.18.19,0,3.67.53.86.13-.8.33-.17.08-.79.33.5-.7a15.31,15.31,0,0,1,2.73-2.87l.67-.53-.3.8L233,109l-.29.8-.17-.83c-.25-1.27-.49-2.53-.71-3.65l0-.18.17-.08,5.67-2.5.16-.08.11.15,2.22,3,.48.64-.75-.3-.12,0-.06,0h0l0,0,.14-.39h.12l0,0-.1.27v0l-.06.12h0l-.59-.24.61-.18h0a14.64,14.64,0,0,1,3.95-.09l.78.09-.71.33-.18.07-.71.34.44-.66,2.07-3.08.1-.14.16.06,5.77,2.24.16.06,0,.16c-.19,1.29-.37,2.56-.54,3.67l-.11.72-.28-.67-.07-.17-.27-.66.58.42a15.2,15.2,0,0,1,2.85,2.73l.44.55-.66-.24-.16-.06-.66-.25.69-.13L257,110l.15,0,.06.13c.87,2,1.72,3.91,2.49,5.65l0,.13-.11.09-3,2.19-.49.37.23-.57.06-.15.23-.56.09.6a14.58,14.58,0,0,1,.08,3.94l-.06.57-.24-.52-.07-.14-.24-.53.48.33,3.05,2.06.1.07,0,.11-2.23,5.7,0,.11-.11,0L253.8,129l-.44-.07.41-.17.11-.05.41-.17-.26.36a14.6,14.6,0,0,1-2.71,2.82l-.31.24.13-.37,0-.1.14-.37.07.39c.25,1.29.47,2.5.68,3.58v.07l-.07,0-5.53,2.38,0,0,0,0-1.57-2.2-.39-.57Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,91.29a9.37,9.37,0,0,1-2.59.06l-1.34,2-3.71-1.43.35-2.38A9.64,9.64,0,0,1,230,87.75l-2.36.47L226,84.58l1.93-1.43a9.39,9.39,0,0,1-.06-2.59l-2-1.34,1.43-3.71,2.38.35A9.6,9.6,0,0,1,231.46,74L231,71.62,234.63,70l1.44,1.92a9.79,9.79,0,0,1,2.59-.06l1.34-2,3.71,1.43-.35,2.38a9.65,9.65,0,0,1,1.88,1.79L247.6,75l1.61,3.64-1.92,1.43a10.3,10.3,0,0,1,.06,2.6l2,1.34-1.43,3.71-2.38-.35a9.94,9.94,0,0,1-1.79,1.88l.47,2.35-3.64,1.62-1.44-1.93Zm0-5.71a4.26,4.26,0,1,0-5.63-2.17A4.25,4.25,0,0,0,239.17,85.58Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,85.58a3.11,3.11,0,0,1-1,.35,4.24,4.24,0,0,1-2.82-.43,4.3,4.3,0,0,1-1.5-1.34,4.35,4.35,0,0,1-.77-2.17,3.85,3.85,0,0,1,.09-1.26,4,4,0,0,1,.47-1.22,4.34,4.34,0,0,1,4.74-2.11,4.37,4.37,0,0,1,1.23.48,4.17,4.17,0,0,1,1,.77,4.36,4.36,0,0,1,1.09,2,4.33,4.33,0,0,1-1.59,4.4,3.29,3.29,0,0,1-.93.5A7.28,7.28,0,0,0,240,85a4.2,4.2,0,0,0,1.46-2.35,4.15,4.15,0,0,0,0-1.92,4.09,4.09,0,0,0-1.06-1.92,3.81,3.81,0,0,0-.94-.73,3.87,3.87,0,0,0-1.16-.44,4.13,4.13,0,0,0-4.48,2,3.62,3.62,0,0,0-.45,1.15,4,4,0,0,0-.1,1.19,4.12,4.12,0,0,0,2.13,3.37,4.27,4.27,0,0,0,2.73.5A7.77,7.77,0,0,0,239.17,85.58Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,91.29s0,0,.1.11l.28.36c.25.34.62.81,1.09,1.43h-.05l3.63-1.63,0,.07c-.14-.72-.3-1.51-.47-2.36v0l0,0a9.88,9.88,0,0,0,1.76-1.87l0,0h.05l2.38.34-.1.05L249.26,84l0,.12-2-1.34,0,0v-.06a9.72,9.72,0,0,0-.07-2.57V80l.05,0,1.93-1.44,0,.13-1.61-3.63.12.07-2.35.46-.07,0,0-.06a9.51,9.51,0,0,0-1.86-1.76l0,0v-.08c.11-.74.22-1.55.34-2.37l.08.13L240,70l.14,0-1.34,2,0,.06h-.07a9.6,9.6,0,0,0-2.56.06h0c-.05,0,.12,0-.12,0h0l0,0-.05-.06-.09-.12-.18-.25-.36-.48-.71-1,.14,0-3.63,1.61.07-.13c.15.79.31,1.58.46,2.35l0,.07-.06,0a9.67,9.67,0,0,0-1.77,1.85l0,.06h-.07l-2.38-.35.13-.07L226,79.26l0-.14,2,1.35,0,0v.07a9.51,9.51,0,0,0,.05,2.56v.07l0,0-1.93,1.44,0-.13c.56,1.28,1.09,2.49,1.6,3.64l-.1-.05,2.36-.46h0l0,0a9.41,9.41,0,0,0,1.86,1.78l0,0v0c-.13.87-.24,1.65-.35,2.38l-.05-.08,3.7,1.45-.06,0,1.35-2v0h0a10.2,10.2,0,0,0,1.95,0l.48,0h.15l-.15,0c-.11,0-.27.05-.48.07a9.58,9.58,0,0,1-2,0h0c-.37.54-.8,1.2-1.33,2l0,0-.05,0L231.48,92l-.06,0v-.06c.11-.74.22-1.52.34-2.38l0,.08a10,10,0,0,1-1.9-1.8l.09,0-2.36.47-.07,0,0-.07-1.62-3.63,0-.08.06,0c.63-.46,1.27-.94,1.93-1.44l-.05.11a10,10,0,0,1-.06-2.62l0,.1-2-1.34-.08,0,0-.08c.47-1.21.94-2.45,1.43-3.71l0-.09h.1l2.37.35-.11.05a9.91,9.91,0,0,1,1.81-1.91l0,.12c-.16-.78-.31-1.56-.47-2.36l0-.09.09,0,3.64-1.62.08,0,.06.07.72,1,.36.49.18.24.09.12,0,.06,0,0v0h0l-.12,0h0a10.13,10.13,0,0,1,2.63-.06l-.12,0,1.34-2,0-.09.09,0,3.71,1.43.09,0v.09l-.35,2.38,0-.11a9.39,9.39,0,0,1,1.9,1.81l-.11-.05,2.36-.46.09,0,0,.09c.56,1.26,1.11,2.49,1.61,3.63l0,.08-.07.06-1.93,1.43,0-.1a10.08,10.08,0,0,1,.06,2.62l0-.1,2,1.35.06,0,0,.07c-.51,1.3-1,2.54-1.44,3.71l0,.06h-.07l-2.37-.35.07,0a9.8,9.8,0,0,1-1.8,1.88l0-.07c.17.85.32,1.65.46,2.36v0l0,0-3.64,1.59h0l0,0L239.5,91.8l-.27-.38Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.12,109.85a18.72,18.72,0,0,1-5,.12l-2.59,3.86-7.17-2.76.67-4.6a19.09,19.09,0,0,1-3.63-3.45l-4.55.9-3.12-7,3.72-2.77a19.14,19.14,0,0,1-.12-5l-3.86-2.59,2.77-7.17,4.59.67a19.15,19.15,0,0,1,3.46-3.63l-.9-4.55,7-3.12,2.78,3.73a18.65,18.65,0,0,1,5-.13l2.59-3.86,7.17,2.77-.67,4.59a18.86,18.86,0,0,1,3.63,3.46l4.56-.9,3.11,7-3.72,2.78a18.71,18.71,0,0,1,.12,5l3.86,2.58-2.76,7.17-4.6-.67A18.8,18.8,0,0,1,293,105.9l.9,4.56-7,3.11-2.77-3.72Zm.05-11a8.24,8.24,0,1,0-10.88-4.19A8.23,8.23,0,0,0,284.17,98.82Z",
    style: {
      fill: "#1EB445",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.14,91.29a9.37,9.37,0,0,1-2.59.06l-1.34,2-3.71-1.43.35-2.38A9.64,9.64,0,0,1,230,87.75l-2.36.47L226,84.58l1.93-1.43a9.39,9.39,0,0,1-.06-2.59l-2-1.34,1.43-3.71,2.38.35A9.6,9.6,0,0,1,231.46,74L231,71.62,234.63,70l1.44,1.92a9.79,9.79,0,0,1,2.59-.06l1.34-2,3.71,1.43-.35,2.38a9.65,9.65,0,0,1,1.88,1.79L247.6,75l1.61,3.64-1.92,1.43a10.3,10.3,0,0,1,.06,2.6l2,1.34-1.43,3.71-2.38-.35a9.94,9.94,0,0,1-1.79,1.88l.47,2.35-3.64,1.62-1.44-1.93Zm0-5.71a4.26,4.26,0,1,0-5.63-2.17A4.25,4.25,0,0,0,239.17,85.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.17,85.58a3.11,3.11,0,0,1-1,.35,4.24,4.24,0,0,1-2.82-.43,4.3,4.3,0,0,1-1.5-1.34,4.35,4.35,0,0,1-.77-2.17,3.85,3.85,0,0,1,.09-1.26,4,4,0,0,1,.47-1.22,4.34,4.34,0,0,1,4.74-2.11,4.37,4.37,0,0,1,1.23.48,4.17,4.17,0,0,1,1,.77,4.36,4.36,0,0,1,1.09,2,4.33,4.33,0,0,1-1.59,4.4,3.29,3.29,0,0,1-.93.5A7.28,7.28,0,0,0,240,85a4.2,4.2,0,0,0,1.46-2.35,4.15,4.15,0,0,0,0-1.92,4.09,4.09,0,0,0-1.06-1.92,3.81,3.81,0,0,0-.94-.73,3.87,3.87,0,0,0-1.16-.44,4.13,4.13,0,0,0-4.48,2,3.62,3.62,0,0,0-.45,1.15,4,4,0,0,0-.1,1.19,4.12,4.12,0,0,0,2.13,3.37,4.27,4.27,0,0,0,2.73.5A7.77,7.77,0,0,0,239.17,85.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.14,91.29s0,0,.1.11l.28.36c.25.34.62.81,1.09,1.43h-.05l3.63-1.63,0,.07c-.14-.72-.3-1.51-.47-2.36v0l0,0a9.88,9.88,0,0,0,1.76-1.87l0,0h.05l2.38.34-.1.05L249.26,84l0,.12-2-1.34,0,0v-.06a9.72,9.72,0,0,0-.07-2.57V80l.05,0,1.93-1.44,0,.13-1.61-3.63.12.07-2.35.46-.07,0,0-.06a9.51,9.51,0,0,0-1.86-1.76l0,0v-.08c.11-.74.22-1.55.34-2.37l.08.13L240,70l.14,0-1.34,2,0,.06h-.07a9.6,9.6,0,0,0-2.56.06h0c-.05,0,.12,0-.12,0h0l0,0-.05-.06-.09-.12-.18-.25-.36-.48-.71-1,.14,0-3.63,1.61.07-.13c.15.79.31,1.58.46,2.35l0,.07-.06,0a9.67,9.67,0,0,0-1.77,1.85l0,.06h-.07l-2.38-.35.13-.07L226,79.26l0-.14,2,1.35,0,0v.07a9.51,9.51,0,0,0,.05,2.56v.07l0,0-1.93,1.44,0-.13c.56,1.28,1.09,2.49,1.6,3.64l-.1-.05,2.36-.46h0l0,0a9.41,9.41,0,0,0,1.86,1.78l0,0v0c-.13.87-.24,1.65-.35,2.38l-.05-.08,3.7,1.45-.06,0,1.35-2v0h0a10.2,10.2,0,0,0,1.95,0l.48,0h.15l-.15,0c-.11,0-.27.05-.48.07a9.58,9.58,0,0,1-2,0h0c-.37.54-.8,1.2-1.33,2l0,0-.05,0L231.48,92l-.06,0v-.06c.11-.74.22-1.52.34-2.38l0,.08a10,10,0,0,1-1.9-1.8l.09,0-2.36.47-.07,0,0-.07-1.62-3.63,0-.08.06,0c.63-.46,1.27-.94,1.93-1.44l-.05.11a10,10,0,0,1-.06-2.62l0,.1-2-1.34-.08,0,0-.08c.47-1.21.94-2.45,1.43-3.71l0-.09h.1l2.37.35-.11.05a9.91,9.91,0,0,1,1.81-1.91l0,.12c-.16-.78-.31-1.56-.47-2.36l0-.09.09,0,3.64-1.62.08,0,.06.07.72,1,.36.49.18.24.09.12,0,.06,0,0v0h0l-.12,0h0a10.13,10.13,0,0,1,2.63-.06l-.12,0,1.34-2,0-.09.09,0,3.71,1.43.09,0v.09l-.35,2.38,0-.11a9.39,9.39,0,0,1,1.9,1.81l-.11-.05,2.36-.46.09,0,0,.09c.56,1.26,1.11,2.49,1.61,3.63l0,.08-.07.06-1.93,1.43,0-.1a10.08,10.08,0,0,1,.06,2.62l0-.1,2,1.35.06,0,0,.07c-.51,1.3-1,2.54-1.44,3.71l0,.06h-.07l-2.37-.35.07,0a9.8,9.8,0,0,1-1.8,1.88l0-.07c.17.85.32,1.65.46,2.36v0l0,0-3.64,1.59h0l0,0L239.5,91.8l-.27-.38Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.73,205.86l1.21-.22s9.5,3.15,9.29,1.3c-.28-2.44-8.92-4.72-9.75-4.77-1.38-.07-9.6.64-10.77,1.23s-8.27,7.25-8.27,7.25L298,220s2.34.3,5.53-2.3c1.61-1.32,4-3.66,4-3.66s-.09-.68.12-.93c.64-.76.2-1.25.2-1.25a1.58,1.58,0,0,0,1.21-1.22,1.18,1.18,0,0,0-.2-.89c-.54-.52-.78-.44-.78-.44a2.35,2.35,0,0,0,1.56-1.49c.26-1.09-1.32-1.64-1.32-1.64",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,207.37a5,5,0,0,1-2.12.18,11.87,11.87,0,0,1-2.29-.34c-.83-.25-1.73-.56-2.68-.88l-2-.69h.13a29.14,29.14,0,0,1-5.05.59,30.53,30.53,0,0,1,5-1.09H309l.07,0,2,.66,2.63.91a13.63,13.63,0,0,0,2.2.43C317.22,207.33,318,207.29,318,207.37Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.08,206.34l-3.13,2.4a3.65,3.65,0,0,0-1,1,1.16,1.16,0,0,0,0,1.28,1.13,1.13,0,0,0,1,.36,3,3,0,0,0,1-.35,34.38,34.38,0,0,0,3.7-2.08",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,208.77A9.48,9.48,0,0,1,307.3,210a12.34,12.34,0,0,1-2,1.1,5.51,5.51,0,0,1-1.3.42,2.13,2.13,0,0,1-.79,0,1.09,1.09,0,0,1-.68-.55,1.45,1.45,0,0,1,.26-1.55,7,7,0,0,1,1-.92c.66-.52,1.26-1,1.78-1.34a7.14,7.14,0,0,1,1.77-1.07,14.46,14.46,0,0,1-1.57,1.32l-1.72,1.41a8.44,8.44,0,0,0-.92.87,1.07,1.07,0,0,0-.21,1.08.92.92,0,0,0,1,.34,6,6,0,0,0,1.21-.36,14.65,14.65,0,0,0,1.95-1A9.53,9.53,0,0,1,309,208.77Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.82,209.6s1-.91,1.37-.84a1.25,1.25,0,0,1,1.22.91c.18.66-.09.88-1.26,2.13",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.82,209.6l-2.58,2.09a3,3,0,0,0-.79.83,1,1,0,0,0,0,1.1.88.88,0,0,0,.8.3,2.31,2.31,0,0,0,.84-.31,28.45,28.45,0,0,0,3-1.81",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.37,210.37a3.73,3.73,0,0,1-1.2,1.57,9.67,9.67,0,0,1-1.75,1.27,10.11,10.11,0,0,1-1.14.58,3.09,3.09,0,0,1-1.41.33,1,1,0,0,1-.75-.41,1.05,1.05,0,0,1-.14-.8,2,2,0,0,1,.77-1.14c.61-.53,1.17-1,1.66-1.35a6.76,6.76,0,0,1,1.66-1.06,13.21,13.21,0,0,1-1.46,1.31c-.45.4-1,.87-1.58,1.41a1.66,1.66,0,0,0-.61.9.53.53,0,0,0,.49.69,3,3,0,0,0,1.2-.29,11.39,11.39,0,0,0,1.11-.53A12.2,12.2,0,0,0,309,211.7C309.9,211,310.31,210.32,310.37,210.37Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.64,212.55a2.26,2.26,0,0,0,2.57.48c.88-.33,1.62-.94,2.47-1.32,2.55-1.16,5.72-.17,8.21-1.45.35-.18.72-.51.62-.88s-.52-.47-.88-.53l-9.14-1.51",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.49,207.34a3.61,3.61,0,0,1,1,.06l2.71.36,4,.61,1.16.18a1.87,1.87,0,0,1,1.28.53.77.77,0,0,1,0,.88,1.51,1.51,0,0,1-.57.5,6,6,0,0,1-1.27.49,34.42,34.42,0,0,1-5,.45,7,7,0,0,0-2,.5c-.59.26-1.12.61-1.64.89a3.31,3.31,0,0,1-2.73.42c-.65-.26-.8-.67-.78-.66a3,3,0,0,0,.84.46,3.15,3.15,0,0,0,2.49-.55c.49-.28,1-.66,1.64-1a7.32,7.32,0,0,1,2.15-.58,42.71,42.71,0,0,0,4.9-.48,6.18,6.18,0,0,0,1.16-.44c.34-.18.54-.48.41-.63s-.55-.26-.94-.32l-1.16-.2-4-.72-2.68-.52A3.48,3.48,0,0,1,296.49,207.34Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43,212.47s.72-.67,1-.62a.94.94,0,0,1,.91.68c.13.48-.07.65-.94,1.57",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.43,212.47,306.52,214a2.24,2.24,0,0,0-.58.61.78.78,0,0,0,0,.82.67.67,0,0,0,.6.22,1.66,1.66,0,0,0,.63-.23,20.52,20.52,0,0,0,2.25-1.34",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,213c.05,0-.19.57-.86,1.2a7.56,7.56,0,0,1-1.3,1,7.49,7.49,0,0,1-.85.43,2.35,2.35,0,0,1-1.07.25.79.79,0,0,1-.6-.33.88.88,0,0,1-.12-.64,1.61,1.61,0,0,1,.59-.87c.47-.37.91-.69,1.27-1,.73-.53,1.2-.84,1.23-.78s-.36.44-1,1l-1.19,1a1.3,1.3,0,0,0-.43.64c0,.25.07.42.32.44a2.21,2.21,0,0,0,.86-.21,8.88,8.88,0,0,0,.82-.39,9,9,0,0,0,1.29-.83C310,213.46,310.27,213,310.33,213Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.16,215.72a11.88,11.88,0,0,0-.22-2.11,12,12,0,0,0-1-1.87c0-.12,1,.46,1.43,1.74A2.39,2.39,0,0,1,301.16,215.72Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,200.69c-4.4-2.25-8.74-2.76-13.49-2.9-5.52-.16-13.3-.93-19.25-.3,0,0-18.71,1.47-18.79,15.52l3,51.93-3.88,23.12,54.33,1.64-.39-27.28c.18,12.24-.42-26.48-.22-36.82.83-7.63,4.47-8.53,5.07-13.49C234.86,207.72,231.93,202.7,228,200.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,198.15s8.26-.14,13.69,2.52,35.17,20.91,35.17,20.91l22.84-12.66,12.08,11.32-26.2,17.3a18.06,18.06,0,0,1-17.24,1.63l-29.54-11.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.27,217.05c.14,0,.28,8.07.31,18s-.06,18-.2,18-.29-8.07-.32-18S229.12,217.05,229.27,217.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160,430.33l-5.15,20.42-8.72,15a2.16,2.16,0,0,0,.91,3h0a2.14,2.14,0,0,0,2,0c3.92-2.12,18.29-10,18.58-11.48.34-1.75,6.86-21.17,6.86-21.17Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,468.74l20.93-12.88-.24.86a3.25,3.25,0,0,1-1.3,1.83c-1.71,1.15-6.49,4.25-17.36,10.18a2.15,2.15,0,0,1-2,0Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.59,448.16a1.31,1.31,0,0,0-.8,1.55,1.26,1.26,0,0,0,1.53.81,1.37,1.37,0,0,0,.83-1.65,1.3,1.3,0,0,0-1.68-.66",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.09,461.16a6.49,6.49,0,0,0-1.34-2.08,6.63,6.63,0,0,0-2.21-1.09c0-.05.3-.14.79-.07a3.32,3.32,0,0,1,1.73.82,3.38,3.38,0,0,1,1,1.62C154.2,460.84,154.15,461.15,154.09,461.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.9,463.47c-.12.06-.59-.78-1.56-1.37a18.36,18.36,0,0,0-1.91-.8,2.4,2.4,0,0,1,2.16.41C151.69,462.39,152,463.45,151.9,463.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.75,458.42a21.45,21.45,0,0,0-2.26-2.28,20.68,20.68,0,0,0-2.82-1.53,4.72,4.72,0,0,1,3.1,1.16A4.81,4.81,0,0,1,157.75,458.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.83,452.34c-.09.11-1.08-.67-2.52-1.13s-2.7-.42-2.71-.56a4.25,4.25,0,0,1,2.85.12A4.18,4.18,0,0,1,159.83,452.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.49,446.39a10.39,10.39,0,0,0-2.59-1.25,11,11,0,0,0-2.88-.07c0-.05.27-.24.81-.38a4.64,4.64,0,0,1,2.17,0,4.69,4.69,0,0,1,1.94,1C161.36,446.05,161.53,446.35,161.49,446.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.25,444a1.72,1.72,0,0,1,.18-.78,5.42,5.42,0,0,1,1.17-1.84,2.46,2.46,0,0,1,1.32-.85.87.87,0,0,1,.89.45,1.39,1.39,0,0,1,.07,1,3,3,0,0,1-3.33,2,3.53,3.53,0,0,1-2.85-2.71,1.22,1.22,0,0,1,.21-1,.86.86,0,0,1,1-.19,3.06,3.06,0,0,1,1.15,1.06,6.44,6.44,0,0,1,1,2,1.83,1.83,0,0,1,.11.79,9.34,9.34,0,0,0-1.32-2.55,2.93,2.93,0,0,0-1-.9.46.46,0,0,0-.54.1.83.83,0,0,0-.1.66,3.13,3.13,0,0,0,2.5,2.32,2.64,2.64,0,0,0,2.85-1.66,1,1,0,0,0,0-.7.48.48,0,0,0-.49-.26,2.25,2.25,0,0,0-1.13.7A7.94,7.94,0,0,0,159.25,444Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.82,433l-1.13,17.15s17.07,5.66,17.17,8.85l-33.36.24.68-26.79Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.42,448.41a1.38,1.38,0,0,0-1,1.53,1.32,1.32,0,0,0,1.51,1,1.44,1.44,0,0,0,1-1.62,1.36,1.36,0,0,0-1.68-.86",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.5,459.26l.07-2.7,32.22.89a2.32,2.32,0,0,1,1.24,1.81Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M228.23,450c0,.17-.82.22-1.64.72s-1.26,1.17-1.41,1.1.12-1,1.12-1.59S228.27,449.87,228.23,450Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.69,451.57c0,.15-.69.41-1.26,1.08s-.75,1.4-.92,1.39-.23-.94.5-1.76S231.69,451.41,231.69,451.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.54,455.81c-.14,0-.35-.79.1-1.67s1.22-1.21,1.28-1.07-.42.6-.77,1.33S233.71,455.8,233.54,455.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.06,446.08c-.07.14-.81-.1-1.74-.07s-1.64.3-1.73.16.63-.7,1.72-.73S228.14,446,228.06,446.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.22,442.61a3.07,3.07,0,0,1-1.67-.06,7.54,7.54,0,0,1-1.73-.59,7.43,7.43,0,0,1-.94-.53,2.17,2.17,0,0,1-.49-.41.7.7,0,0,1,0-.87.9.9,0,0,1,.72-.35,2.25,2.25,0,0,1,.63.1,6.77,6.77,0,0,1,1,.39,5.72,5.72,0,0,1,1.51,1.06c.76.74,1,1.35.94,1.38s-.43-.46-1.2-1.08a6.27,6.27,0,0,0-1.46-.88,7.09,7.09,0,0,0-.95-.33c-.35-.1-.65-.11-.75,0s0,.08,0,.19a1.67,1.67,0,0,0,.36.3,10.13,10.13,0,0,0,.87.53,10,10,0,0,0,1.59.67A10.65,10.65,0,0,1,228.22,442.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,442.84a2.78,2.78,0,0,1-.39-1.63,5.32,5.32,0,0,1,.29-1.82,5.51,5.51,0,0,1,.45-1,1.39,1.39,0,0,1,1.09-.81.79.79,0,0,1,.69.49,2.7,2.7,0,0,1,.15.61,3.79,3.79,0,0,1-.8,2.83c-.68.85-1.36,1-1.37,1s.52-.38,1-1.19a3.8,3.8,0,0,0,.58-1.55,3.5,3.5,0,0,0,0-1c0-.35-.17-.64-.3-.61s-.46.25-.6.53a4.9,4.9,0,0,0-.44.89,6,6,0,0,0-.38,1.66C227.94,442.2,228.09,442.82,228,442.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.82 284.01 178 283.63 153.45 444.92 174.54 447.6 201.57 314.98 209.66 448.07 209.68 448.46 232.49 448.07 228.82 284.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.86,281.74a8.58,8.58,0,0,1-1.51.57c-1,.34-2.43.76-4.23,1.2a64.23,64.23,0,0,1-6.42,1.18,69.67,69.67,0,0,1-8,.53,67.93,67.93,0,0,1-8-.48,61.85,61.85,0,0,1-6.43-1.15c-1.81-.43-3.26-.84-4.24-1.18a10,10,0,0,1-1.51-.55,8.24,8.24,0,0,1,1.57.36c1,.28,2.45.63,4.26,1s4,.74,6.4,1a74.73,74.73,0,0,0,7.93.44,77,77,0,0,0,7.92-.48c2.42-.31,4.59-.67,6.4-1.07s3.26-.75,4.25-1A10.3,10.3,0,0,1,222.86,281.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,165.6a30,30,0,0,1-1.68-5.62,10,10,0,0,1,.62-5.76,6.08,6.08,0,0,1,4.4-3.53c1.2-.18,2.46.08,3.61-.28,1.34-.42,2.27-1.59,3.34-2.5a10.23,10.23,0,0,1,6-2.39,6.06,6.06,0,0,1,3.33.64,3.43,3.43,0,0,1,1.81,2.76,16,16,0,0,1,4.15-.8,5.49,5.49,0,0,1,3.9,1.36,3.32,3.32,0,0,1,.73,3.87,2.72,2.72,0,0,1,3.44,1.15,3.49,3.49,0,0,1-.4,3.75,6.55,6.55,0,0,1-4,2.05,9.47,9.47,0,0,1-4.11-.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.13,208.81h0A9.86,9.86,0,0,0,216,198.73c-.09-3.18-.16-5.9-.14-6.28,0,0,7.92-.86,8.39-8.72s0-26,0-26h0a27.38,27.38,0,0,0-27.64,2.16l-1.21.84.93,38.51A9.86,9.86,0,0,0,205.13,208.81Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.84,192.33a18.32,18.32,0,0,1-10.12-3.4s2.16,5.78,10.05,5.44Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.92,168.93c-.14-.07-5.34-1.86-5.42,3.53s5.35,4.36,5.36,4.21S195.92,168.93,195.92,168.93Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.24,174.6s-.09.06-.25.13a.92.92,0,0,1-.7,0,2.34,2.34,0,0,1-1-2.1,3.18,3.18,0,0,1,.29-1.34,1.1,1.1,0,0,1,.71-.71.48.48,0,0,1,.55.26c.07.16,0,.26.07.27s.11-.09.07-.31a.61.61,0,0,0-.2-.34.7.7,0,0,0-.52-.14,1.28,1.28,0,0,0-1,.82,3.12,3.12,0,0,0-.35,1.49A2.45,2.45,0,0,0,193.2,175a1,1,0,0,0,.86-.13C194.23,174.73,194.26,174.61,194.24,174.6Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.46,160.17A18.5,18.5,0,0,1,213,159c-4-1.73-8.6-2.44-9.56-1.6s-1,4.86-4.76,6.24c0,0,1,11.35-2.07,11.35-2.26,0-2.12-15.89-2.12-15.89l7.28-4,8.08-2,7.64-.41,7.23,1.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.33,169.35a1.15,1.15,0,0,1-1.11,1.16,1.1,1.1,0,0,1-1.19-1,1.16,1.16,0,0,1,1.11-1.16A1.11,1.11,0,0,1,222.33,169.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.58,168.06c-.15.15-1-.5-2.26-.49s-2.14.62-2.27.47.08-.34.47-.63a3.15,3.15,0,0,1,1.83-.56,3,3,0,0,1,1.79.58C222.52,167.72,222.65,168,222.58,168.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.21,169.64a1.15,1.15,0,0,1-1.11,1.16,1.09,1.09,0,0,1-1.19-1A1.17,1.17,0,0,1,209,168.6,1.11,1.11,0,0,1,210.21,169.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.41,168.29c-.14.15-1-.5-2.25-.49s-2.14.62-2.28.47.08-.34.48-.63a3.22,3.22,0,0,1,1.82-.56,3,3,0,0,1,1.79.58C210.35,168,210.48,168.22,210.41,168.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.9,177.47a8.17,8.17,0,0,1,2-.37c.32,0,.62-.09.67-.31a1.57,1.57,0,0,0-.21-.93c-.3-.77-.61-1.57-.93-2.41a41.17,41.17,0,0,1-2.1-6.29,40.79,40.79,0,0,1,2.6,6.11l.89,2.42a1.83,1.83,0,0,1,.17,1.24.81.81,0,0,1-.52.46,2.28,2.28,0,0,1-.54.07A8.24,8.24,0,0,1,214.9,177.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.26,178.32c.2,0,.2,1.33,1.35,2.29s2.58.8,2.59,1-.31.26-.92.28a3.35,3.35,0,0,1-2.16-.75,3,3,0,0,1-1.05-1.92C211,178.65,211.17,178.32,211.26,178.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73,163.44c-.12.34-1.36.18-2.81.35s-2.63.57-2.82.27c-.08-.14.12-.46.59-.79a4.92,4.92,0,0,1,4.29-.47C210.52,163,210.78,163.28,210.73,163.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.12,164.48c-.22.28-1.07,0-2.09,0s-1.9.19-2.1-.1,0-.43.43-.69a2.82,2.82,0,0,1,1.7-.46,2.89,2.89,0,0,1,1.68.56C222.1,164.05,222.22,164.34,222.12,164.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.75,
    y: 245.01,
    width: 148.64,
    height: 60.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,305.38s0-.37,0-1.08,0-1.76,0-3.13c0-2.75,0-6.8,0-12,0-10.42-.05-25.5-.09-44.15l.17.16-148.63.07h0L106,245c0,21.14,0,41.55,0,60.37l-.22-.22,106.57.1,30.91.07,8.28,0,2.14,0h.74l-.71,0h-2.12l-8.22,0-30.87.06-106.72.11h-.23v-.23c0-18.82,0-39.23,0-60.37v-.24h.25l148.63.07h.16V245c0,18.7-.07,33.8-.09,44.25,0,5.19,0,9.23,0,12,0,1.36,0,2.4,0,3.11S254.39,305.38,254.39,305.38Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.9,253.15c0-.13,33.22-.24,74.2-.24s74.2.11,74.2.24-33.22.24-74.2.24S105.9,253.28,105.9,253.15Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.12,249.51a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,112.12,249.51Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.82,249.51a1.08,1.08,0,1,1-2.16,0,1.08,1.08,0,0,1,2.16,0Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.46,249.51a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,119.46,249.51Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 118.38,
    y: 262.96,
    width: 35.9,
    height: 35.9,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.38,
    y: 262.96,
    width: 35.9,
    height: 35.9,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,272.58c0,.13-18.47.24-41.26.24s-41.26-.11-41.26-.24,18.47-.23,41.26-.23S244.1,272.45,244.1,272.58Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.1,279.9c0,.13-18.47.23-41.26.23s-41.26-.1-41.26-.23,18.47-.24,41.26-.24S244.1,279.77,244.1,279.9Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.7,287.21a2.24,2.24,0,0,1-.54.05l-1.54,0-5.7.08-18.78.07-18.78-.07-5.69-.08-1.55,0a2.34,2.34,0,0,1-.54-.05,3.37,3.37,0,0,1,.54,0l1.55,0,5.69-.07,18.78-.07,18.78.07,5.7.07,1.54,0A3.18,3.18,0,0,1,214.7,287.21Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,202.27s-7.25,3.73-10.47,17.12c-1.58,6.61-8.15,28.11-9.21,40.13C161.65,267,169.8,274,177.21,275l.34,0c15.42,3.09,30.32-1.1,30.32-1.1l-3.1-14.06s-19.7-3.82-22.21-5l7.64-30.21S195.92,203.56,182,202.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.77,205.3a.93.93,0,0,1,.27,0c.18,0,.45.07.8.16a8.63,8.63,0,0,1,2.84,1.29,8.5,8.5,0,0,1,3,3.92,16.65,16.65,0,0,1,1,6.53,25.18,25.18,0,0,1-.4,3.85c-.27,1.33-.65,2.66-1,4.07l-2.24,9c-1.61,6.36-3.37,13.39-5.25,20.85l-.18-.31c2.31.65,4.76,1.29,7.25,1.91s5.21,1.23,7.76,1.72c1.27.24,2.54.46,3.79.61a18.73,18.73,0,0,1,1.91.28,4.88,4.88,0,0,1,.94.3,1.73,1.73,0,0,1,.81.68,5.9,5.9,0,0,1,.63,1.82l.39,1.79c.25,1.19.46,2.36.67,3.51.41,2.31.8,4.53,1.31,6.63l.06.22-.22.06a73.26,73.26,0,0,1-23.38,1.92,56.31,56.31,0,0,1-8.85-1.31,2.75,2.75,0,0,1,.6.07l1.72.27c1.5.22,3.72.51,6.55.7a74.87,74.87,0,0,0,23.25-2.1l-.17.28c-.53-2.12-.93-4.35-1.35-6.65-.21-1.15-.43-2.32-.67-3.5-.14-.58-.27-1.17-.4-1.77a5.6,5.6,0,0,0-.56-1.66,2.11,2.11,0,0,0-1.45-.77,17.53,17.53,0,0,0-1.85-.26c-1.27-.16-2.55-.38-3.83-.61-2.56-.49-5.16-1.08-7.78-1.72s-5-1.27-7.27-1.93l-.24-.06.06-.25c1.89-7.45,3.68-14.48,5.3-20.83q1.21-4.77,2.3-9c.34-1.4.73-2.76,1-4a24.53,24.53,0,0,0,.42-3.8,16.13,16.13,0,0,0-.91-6.41,8.36,8.36,0,0,0-2.86-3.87,9.45,9.45,0,0,0-2.76-1.35c-.34-.1-.6-.15-.78-.2A.91.91,0,0,1,183.77,205.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.09,260.87a3.68,3.68,0,0,1,.54-1.72,8.17,8.17,0,0,1,7.2-4.29,3.75,3.75,0,0,1,1.77.35c0,.09-.69,0-1.76,0a9,9,0,0,0-3.94,1.23,8.81,8.81,0,0,0-3,2.87C173.38,260.24,173.18,260.9,173.09,260.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.59,261.19l5.68-.63a31.39,31.39,0,0,1,3.87-5.23c1.54-1.35,9.47-5.15,9.47-5.15a2.2,2.2,0,0,1,0,2.79,34.93,34.93,0,0,1-4.27,2.73h0a2.16,2.16,0,0,0,2.47,2.73c2.32-.42,5-.91,5.38-.91s2.72-2.19,4.43-3.86a1.44,1.44,0,0,1,2.43,1.33.72.72,0,0,1-.2.34s2.45-.08.26,3.21c0,0,.51,3-1.29,4.43,0,0-.77,3.67-1.92,4.93s-12.4,3.67-12.4,3.67l-11.72,1.14Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.81,261.92a7.17,7.17,0,0,0,2,.05,10.7,10.7,0,0,0,4.73-1.25,9.76,9.76,0,0,0,3.29-3.61,6.41,6.41,0,0,0,.86-1.83,10,10,0,0,0-1.17,1.63,11,11,0,0,1-3.25,3.37,11.93,11.93,0,0,1-4.5,1.32A8.51,8.51,0,0,0,223.81,261.92Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,264.52a3.75,3.75,0,0,0,1.84.15,14.26,14.26,0,0,0,2-.29,6.2,6.2,0,0,0,2.32-.95,10.53,10.53,0,0,0,1.72-1.77l1.24-1.54a6.65,6.65,0,0,0,1-1.5,6.65,6.65,0,0,0-1.32,1.26c-.38.41-.84.91-1.32,1.47A12.64,12.64,0,0,1,230.8,263a6,6,0,0,1-2.12.89,16.65,16.65,0,0,1-1.91.39C225.67,264.47,225,264.45,225,264.52Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.56,267.42c0,.21,2-.21,4.42-.88a2.06,2.06,0,0,0,.87-.52,7.14,7.14,0,0,0,.61-.63,9.23,9.23,0,0,0,.87-1.17c.44-.72.56-1.23.49-1.25s-.3.41-.79,1c-.25.32-.56.68-.92,1.06a6.49,6.49,0,0,1-.6.56,1.57,1.57,0,0,1-.66.41c-1.21.33-2.28.67-3,.92A6.23,6.23,0,0,0,226.56,267.42Z",
    style: {
      fill: "#aa6550"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M408.71,125.32l.64,0a13.16,13.16,0,0,1,1.88.15,17.37,17.37,0,0,1,6.94,2.4,17.91,17.91,0,0,1,4.23,3.42,18.69,18.69,0,0,1,3.53,5.53,19.23,19.23,0,0,1,1.38,7.52q0,4.11,0,8.73c0,24.68,0,60.38.07,104.5s0,96.65,0,155v27.76a19.69,19.69,0,0,1-.71,5.65,18.75,18.75,0,0,1-2.36,5.22,19.89,19.89,0,0,1-3.86,4.28,18.71,18.71,0,0,1-10.7,4.15c-3.88.12-7.74,0-11.64.06l-23.58,0-48.41,0H288.88a19.59,19.59,0,0,1-12.06-3.33,19,19,0,0,1-7.34-10.14,20.51,20.51,0,0,1-.77-6.27v-31q0-24.58,0-48.42c0-31.74,0-62.37,0-91.54s0-56.89,0-82.83q0-19.46,0-37.53c0-1.51,0-3,0-4.5,0-.74.06-1.5.1-2.24s.19-1.49.38-2.21a19,19,0,0,1,3.89-7.85,19.26,19.26,0,0,1,6.87-5.13,19.47,19.47,0,0,1,8.24-1.56l16.14,0H316a6,6,0,0,1,3.65,1,6.07,6.07,0,0,1,2.26,3,9.71,9.71,0,0,1,.38,3.65v1.81a12.78,12.78,0,0,0,.06,1.76,5.78,5.78,0,0,0,1.38,3.1,5.46,5.46,0,0,0,2.83,1.76,6.2,6.2,0,0,0,1.67.17h8.39l24.42,0,10.77,0c.85,0,1.72,0,2.52,0a5.46,5.46,0,0,0,2.27-.8,5.91,5.91,0,0,0,2.6-3.73,10,10,0,0,0,.14-2.25c0-.75,0-1.49,0-2.22a12,12,0,0,1,.09-2.16,6.24,6.24,0,0,1,.7-2,5.82,5.82,0,0,1,3-2.61,9.36,9.36,0,0,1,3.68-.4l12,0,7.39,0,2.51,0-2.51,0-7.39,0-12,0a9.31,9.31,0,0,0-3.62.39,5.66,5.66,0,0,0-2.86,2.55,6.08,6.08,0,0,0-.68,1.93,12.38,12.38,0,0,0-.08,2.12v2.22a9.91,9.91,0,0,1-.15,2.29,6.07,6.07,0,0,1-2.68,3.87,5.72,5.72,0,0,1-2.35.84c-.86.07-1.69,0-2.55,0H328.25a6.85,6.85,0,0,1-1.74-.17,5.81,5.81,0,0,1-3-1.85,6.22,6.22,0,0,1-1.46-3.27,13.65,13.65,0,0,1-.06-1.8v-1.81a9.76,9.76,0,0,0-.36-3.54,5.83,5.83,0,0,0-2.15-2.82,5.58,5.58,0,0,0-3.46-1H288.31a19.17,19.17,0,0,0-8.09,1.53,18.9,18.9,0,0,0-6.72,5,18.49,18.49,0,0,0-3.81,7.69c-.18.7-.24,1.44-.37,2.16s-.09,1.46-.1,2.2v4.5q0,18.06,0,37.53c0,25.94,0,53.66,0,82.83v91.54q0,23.81,0,48.42v31A19.7,19.7,0,0,0,270,446a18.41,18.41,0,0,0,7.14,9.86,19,19,0,0,0,11.76,3.24h37.27l48.41,0,23.58,0c3.89,0,7.79.06,11.61-.05a18.24,18.24,0,0,0,10.42-4,19.83,19.83,0,0,0,3.75-4.17,18.21,18.21,0,0,0,2.31-5.08,19.4,19.4,0,0,0,.69-5.52v-5.62q0-11.19,0-22.14c0-58.33.06-110.86.09-155s.08-79.82.1-104.5q0-4.62,0-8.73a18.75,18.75,0,0,0-1.35-7.46,18.36,18.36,0,0,0-3.48-5.5,18.49,18.49,0,0,0-11.08-5.86,15.61,15.61,0,0,0-1.87-.17Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.85,217.1a12.17,12.17,0,0,1,3.5-.26l-.26.26h0v-.68c0-.22,0-.44,0-.66,0-.42,0-.8.06-1.11.05-.64.11-1,.18-1s.14.39.19,1c0,.31,0,.69,0,1.11,0,.22,0,.44,0,.66v.68h0l-.26.26A12.17,12.17,0,0,1,408.85,217.1Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.35,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.84,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.34,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.83,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.33,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.82,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.31,217.1a22.1,22.1,0,0,1,6.76,0,22.1,22.1,0,0,1-6.76,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.81,217.1a22,22,0,0,1,6.75,0,22,22,0,0,1-6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.56,213.6a12.17,12.17,0,0,1,.26,3.5l-.26-.26h1.36q.63,0,1.11.06c.63,0,1,.11,1,.18s-.4.14-1,.18q-.48,0-1.11.06l-.66,0h-.7l-.27-.26A11.56,11.56,0,0,1,290.56,213.6Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.56,199.9a22.69,22.69,0,0,1,0,6.85,21.86,21.86,0,0,1,0-6.85Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.56,186.21a22.62,22.62,0,0,1,0,6.84,21.8,21.8,0,0,1,0-6.84Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.06,175.86a12.17,12.17,0,0,1-3.5.26c.52-.52.14-.15.26-.26h0v1.34q0,.63-.06,1.11c-.05.63-.11,1-.18,1s-.14-.4-.19-1c0-.32,0-.69-.05-1.11l0-.66v-.68h0l.27-.26A11.76,11.76,0,0,1,294.06,175.86Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.56,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.07,175.86a22.1,22.1,0,0,1-6.76,0,22.1,22.1,0,0,1,6.76,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.57,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.08,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.58,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.09,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.59,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.1,175.86a22,22,0,0,1-6.75,0,22,22,0,0,1,6.75,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35,179.36a12.17,12.17,0,0,1-.26-3.5c.52.52.15.14.26.26H411l-1.11-.06c-.64,0-1-.11-1-.18s.39-.14,1-.19l1.11,0,.66,0h.7l.26.26A11.76,11.76,0,0,1,412.35,179.36Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35,193.05a22.62,22.62,0,0,1,0-6.84,22.62,22.62,0,0,1,0,6.84Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35,206.75a22.69,22.69,0,0,1,0-6.85,22.69,22.69,0,0,1,0,6.85Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.76,
    y: 174.78,
    width: 2.15,
    height: 2.15,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.48,
    y: 216.03,
    width: 2.15,
    height: 2.15,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.38,
    y: 216.03,
    width: 2.15,
    height: 2.15,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.38,
    y: 174.33,
    width: 2.15,
    height: 2.15,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,155.32c0,.08-3.06.17-6.84.2s-6.84,0-6.84-.08,3.06-.17,6.84-.21S412.29,155.24,412.3,155.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32,158.82c0,.08-3.06.17-6.83.2s-6.84,0-6.84-.09,3.06-.17,6.84-.2S412.32,158.74,412.32,158.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.35,162.32c0,.08-3.06.17-6.83.2s-6.84,0-6.84-.09,3.06-.17,6.84-.2S412.35,162.24,412.35,162.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.53,277.77c0,.13-9.46.24-21.11.24s-21.12-.11-21.12-.24,9.45-.24,21.12-.24S370.53,277.63,370.53,277.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,286.43c0,.13-17,.24-37.94.24s-37.95-.11-37.95-.24,17-.24,37.95-.24S404.19,286.3,404.19,286.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,292.62c0,.13-16.79.24-37.5.24s-37.5-.11-37.5-.24,16.79-.24,37.5-.24S403.3,292.49,403.3,292.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.58,298.52c0,.14-9.91.24-22.14.24s-22.14-.1-22.14-.24,9.91-.24,22.14-.24S372.58,298.39,372.58,298.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.53,372c0,.13-9.46.24-21.11.24s-21.12-.11-21.12-.24,9.45-.24,21.12-.24S370.53,371.83,370.53,372Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.19,380.63c0,.13-17,.24-37.94.24s-37.95-.11-37.95-.24,17-.24,37.95-.24S404.19,380.49,404.19,380.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,386.82c0,.13-16.79.24-37.5.24s-37.5-.11-37.5-.24,16.79-.24,37.5-.24S403.3,386.68,403.3,386.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.58,392.72c0,.13-9.91.24-22.14.24s-22.14-.11-22.14-.24,9.91-.24,22.14-.24S372.58,392.59,372.58,392.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.64,235.15c0,.13-9.45.24-21.11.24s-21.11-.11-21.11-.24,9.45-.24,21.11-.24S370.64,235,370.64,235.15Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.31,243.82c0,.13-17,.24-37.95.24s-37.94-.11-37.94-.24,17-.24,37.94-.24S404.31,243.68,404.31,243.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.41,250c0,.14-16.79.25-37.49.25s-37.5-.11-37.5-.25,16.78-.24,37.5-.24S403.41,249.87,403.41,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.7,255.91c0,.13-9.92.24-22.14.24s-22.14-.11-22.14-.24,9.91-.24,22.14-.24S372.7,255.78,372.7,255.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,257.73a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,257.73a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,246.32a23.69,23.69,0,0,1,0,7,23.69,23.69,0,0,1,0-7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,234.14a4.75,4.75,0,0,1-1.83.23l.23-.23c0,.49,0,1.07,0,1.68a11.76,11.76,0,0,1-.26,3.5,12.17,12.17,0,0,1-.26-3.5c0-.61,0-1.19,0-1.68v-.24h.22A5,5,0,0,1,295.45,234.14Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45,234.14a23.69,23.69,0,0,1-7,0,23.69,23.69,0,0,1,7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,240.38a11.76,11.76,0,0,1-.26-3.5c0-1.12,0-2.11.1-2.74l.16.16c-.48,0-.76-.1-.76-.16s.28-.12.76-.16h.14l0,.17c.06.63.1,1.62.1,2.74A12.17,12.17,0,0,1,317.21,240.38Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,254.38a23.69,23.69,0,0,1,0-7,23.69,23.69,0,0,1,0,7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 256.58,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 232.2,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 256.58,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 232.84,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,301.15a23.69,23.69,0,0,1,7,0,22.82,22.82,0,0,1-7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,301.15a23.69,23.69,0,0,1,7,0,22.82,22.82,0,0,1-7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,289.74a23.69,23.69,0,0,1,0,7,23.69,23.69,0,0,1,0-7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,277.57a5,5,0,0,1-1.83.23l.23-.23c0,.49,0,1.06,0,1.67a11.71,11.71,0,0,1-.26,3.5,12.12,12.12,0,0,1-.26-3.5c0-.61,0-1.18,0-1.67v-.24h.22A4.75,4.75,0,0,1,295.45,277.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45,277.57a23.69,23.69,0,0,1-7,0,23.69,23.69,0,0,1,7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,283.81a11.76,11.76,0,0,1-.26-3.5c0-1.12,0-2.11.1-2.74l.16.16c-.48-.05-.76-.1-.76-.16s.28-.12.76-.16l.14,0,0,.18c.06.63.1,1.62.1,2.74A12.17,12.17,0,0,1,317.21,283.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,297.81a23.69,23.69,0,0,1,0-7,23.69,23.69,0,0,1,0,7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 300.01,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 275.62,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 300.01,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 276.26,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.33,347.14a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.33,347.14a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.75,335.73a23.69,23.69,0,0,1,0,7,23.69,23.69,0,0,1,0-7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,323.56a5.06,5.06,0,0,1-1.82.22l.23-.22c0,.49,0,1.06,0,1.67a12.17,12.17,0,0,1-.26,3.5,11.76,11.76,0,0,1-.26-3.5c0-.61,0-1.18,0-1.67v-.24h.22A4.67,4.67,0,0,1,295.57,323.56Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.57,323.56a23.69,23.69,0,0,1-7,0,23.69,23.69,0,0,1,7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,329.8a12.17,12.17,0,0,1-.26-3.5c0-1.12,0-2.11.1-2.74l.16.16c-.48-.05-.76-.1-.76-.16s.28-.12.76-.16l.15,0v.18c.07.63.1,1.62.1,2.74A11.76,11.76,0,0,1,317.33,329.8Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.33,343.8a23.69,23.69,0,0,1,0-7,23.69,23.69,0,0,1,0,7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 345.99,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.78,
    y: 321.61,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.44,
    y: 345.99,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.44,
    y: 322.25,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,393a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,393a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,381.59a23.69,23.69,0,0,1,0,7,23.69,23.69,0,0,1,0-7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,369.42a5,5,0,0,1-1.83.23l.23-.23c0,.49,0,1.06,0,1.67a11.71,11.71,0,0,1-.26,3.5,12.12,12.12,0,0,1-.26-3.5c0-.61,0-1.18,0-1.67v-.24h.22A5,5,0,0,1,295.45,369.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45,369.42a23.69,23.69,0,0,1-7,0,23.69,23.69,0,0,1,7,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,375.66a11.76,11.76,0,0,1-.26-3.5c0-1.12,0-2.11.1-2.74l.16.16c-.48,0-.76-.1-.76-.16s.28-.12.76-.16h.14l0,.17c.06.63.1,1.62.1,2.74A12.17,12.17,0,0,1,317.21,375.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,389.66a23.69,23.69,0,0,1,0-7,23.69,23.69,0,0,1,0,7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 391.86,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 367.47,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 391.86,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 368.11,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.21,440.47a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.21,440.47a23.69,23.69,0,0,1,7,0,23.69,23.69,0,0,1-7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,429.05a23.69,23.69,0,0,1,0,7,23.69,23.69,0,0,1,0-7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.45,416.88a5,5,0,0,1-1.83.23l.23-.23c0,.49,0,1.06,0,1.67a11.71,11.71,0,0,1-.26,3.5,12.12,12.12,0,0,1-.26-3.5c0-.61,0-1.18,0-1.67v-.24h.22A5,5,0,0,1,295.45,416.88Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.45,416.88a23.69,23.69,0,0,1-7,0,23.69,23.69,0,0,1,7,0Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,423.12a11.76,11.76,0,0,1-.26-3.5c0-1.12,0-2.11.1-2.74l.16.16c-.48,0-.76-.1-.76-.16s.28-.12.76-.16h.14l0,.17c.06.63.1,1.62.1,2.74A12.17,12.17,0,0,1,317.21,423.12Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.21,437.12a23.69,23.69,0,0,1,0-7,23.69,23.69,0,0,1,0,7Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 439.32,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.65,
    y: 414.93,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 439.32,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.32,
    y: 415.57,
    width: 2.61,
    height: 2.61,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,322.76c0,.13-9.45.24-21.11.24s-21.11-.11-21.11-.24,9.45-.24,21.11-.24S369.63,322.63,369.63,322.76Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,331.43c0,.13-17,.24-37.94.24s-37.95-.11-37.95-.24,17-.24,37.95-.24S403.3,331.29,403.3,331.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.41,337.62c0,.13-16.79.24-37.5.24s-37.5-.11-37.5-.24,16.79-.24,37.5-.24S402.41,337.48,402.41,337.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.69,343.52c0,.13-9.91.24-22.14.24s-22.14-.11-22.14-.24,9.91-.24,22.14-.24S371.69,343.39,371.69,343.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.63,418.93c0,.14-9.45.24-21.11.24s-21.11-.1-21.11-.24,9.45-.24,21.11-.24S369.63,418.8,369.63,418.93Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.3,427.6c0,.13-17,.24-37.94.24s-37.95-.11-37.95-.24,17-.24,37.95-.24S403.3,427.47,403.3,427.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.41,433.79c0,.13-16.79.24-37.5.24s-37.5-.11-37.5-.24,16.79-.24,37.5-.24S402.41,433.65,402.41,433.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.69,439.69c0,.13-9.91.24-22.14.24s-22.14-.11-22.14-.24,9.91-.24,22.14-.24S371.69,439.56,371.69,439.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,161.86l.27,0,.77,0,2.83-.07-.08.08c0-.63,0-1.31,0-2.05,0-.38,0-.74,0-1.19a1.11,1.11,0,0,1,.95-.87c.46,0,.86,0,1.36,0a1.12,1.12,0,0,1,.93,1.1c0,1,0,2,0,3l-.13-.13,3.57,0-.13.14c0-1.44,0-2.93,0-4.45,0-.39,0-.76,0-1.14a1.18,1.18,0,0,0-.51-.84l-1.56-1.54-1.5-1.49-.73-.72c-.26-.24-.45-.49-.74-.55a.92.92,0,0,0-.82.16c-.22.18-.45.44-.67.65l-1.28,1.29c-.81.84-1.65,1.61-2.26,2.33a2.62,2.62,0,0,0-.18,1.33v1.26c0,.77,0,1.45,0,2s0,.94,0,1.29,0,.46,0,.47a2.17,2.17,0,0,1,0-.43c0-.34,0-.76,0-1.27s0-1.27-.05-2c0-.4,0-.83,0-1.28,0-.23,0-.46,0-.7a1.42,1.42,0,0,1,.19-.75c.66-.81,1.45-1.53,2.27-2.39.41-.42.83-.86,1.27-1.3.23-.23.41-.45.69-.69a1.21,1.21,0,0,1,1-.2,2,2,0,0,1,.86.61l.73.72,1.51,1.48,1.57,1.54a2.81,2.81,0,0,1,.4.43,1.28,1.28,0,0,1,.19.6c0,.38,0,.76,0,1.14,0,1.53,0,3,0,4.45v.14h-.14l-3.57,0h-.13v-.13c0-1,0-2,0-3a.86.86,0,0,0-.72-.87c-.41,0-.89,0-1.29,0a.86.86,0,0,0-.77.69c0,.36,0,.78,0,1.15v2.13h-.08l-2.88,0h-.75A1,1,0,0,1,291,161.86Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.76,192.27l-.24,0-.72,0-2.75,0-10.12.09-15,0-8.87,0h-2.32a7.74,7.74,0,0,0-2.28.18,4.26,4.26,0,0,0-2.95,3.17,14.21,14.21,0,0,0-.09,2.37c0,.81,0,1.61,0,2.4v4.69c0,3.08,0,6,0,8.87,0,5.64,0,10.73-.06,15s-.06,7.69-.08,10.12c0,1.16,0,2.08-.05,2.75q0,.43,0,.72c0,.16,0,.24,0,.24a.75.75,0,0,1,0-.24q0-.28,0-.72c0-.67,0-1.59-.05-2.75,0-2.43,0-5.88-.08-10.12s0-9.38,0-15c0-2.83,0-5.79,0-8.87v-7.09a14,14,0,0,1,.1-2.48,4.78,4.78,0,0,1,3.32-3.56,8,8,0,0,1,2.42-.19h11.19l15,.06,10.12.08,2.75.05.72,0A1.1,1.1,0,0,1,289.76,192.27Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.37,192.19a1.58,1.58,0,1,1-1.58-1.58A1.58,1.58,0,0,1,292.37,192.19Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.16,205.07c-.05,0-.05-.36-.22-1a4,4,0,0,0-1.47-2.09,3.88,3.88,0,0,0-3.61-.5,3.78,3.78,0,0,0,0,7.09,3.85,3.85,0,0,0,3.61-.5,4,4,0,0,0,1.47-2.09c.17-.6.17-1,.22-1a1.89,1.89,0,0,1,0,1,4,4,0,0,1-1.45,2.33,4.15,4.15,0,0,1-4,.66,4.24,4.24,0,0,1,0-8,4.21,4.21,0,0,1,4,.66,4,4,0,0,1,1.45,2.33A1.94,1.94,0,0,1,321.16,205.07Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-16"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.55,459.66l-117.48-.07A25.59,25.59,0,0,1,388.49,434l.06-294.54a25.59,25.59,0,0,1,25.61-25.58l117.48.07a25.59,25.59,0,0,1,25.58,25.59l-.06,294.54A25.59,25.59,0,0,1,531.55,459.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.52,124.36H508.74a5.66,5.66,0,0,0-5.53,5.78v4.13a5.64,5.64,0,0,1-5.53,5.78l-44.4,0a5.66,5.66,0,0,1-5.53-5.78V130.1a5.67,5.67,0,0,0-5.54-5.79H414.27a17.93,17.93,0,0,0-17.94,17.92l-.05,287.48a17.92,17.92,0,0,0,17.91,17.93l117.25.06a17.91,17.91,0,0,0,17.93-17.91l.06-287.49A17.94,17.94,0,0,0,531.52,124.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,153.39c0,.08-3,.17-6.61.2s-6.62,0-6.62-.09,3-.16,6.61-.19S535,153.32,535,153.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,156.78c0,.08-3,.16-6.62.19s-6.61,0-6.61-.08,3-.17,6.61-.2S535,156.7,535,156.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535,160.16c0,.08-3,.17-6.62.2s-6.62,0-6.62-.09,3-.16,6.62-.19S535,160.09,535,160.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.62,164l.28,0,.76,0,2.83-.07-.08.08c0-.63,0-1.31,0-2.05,0-.38,0-.74,0-1.18a1.08,1.08,0,0,1,.95-.87c.46,0,.86,0,1.35,0a1.1,1.1,0,0,1,.93,1.09c0,1,0,2,0,3l-.13-.13,3.56,0-.13.13c0-1.43,0-2.92,0-4.44,0-.38,0-.75,0-1.13a1.13,1.13,0,0,0-.5-.84L422.83,156l-1.5-1.48-.73-.72a1.71,1.71,0,0,0-.74-.55.93.93,0,0,0-.82.16c-.21.18-.44.44-.66.65l-1.28,1.29c-.8.84-1.64,1.6-2.25,2.32a2.51,2.51,0,0,0-.18,1.33v1.26c0,.77,0,1.44,0,2s0,.94,0,1.29a2.61,2.61,0,0,1,0,.47s0-.14,0-.43,0-.76,0-1.27,0-1.27,0-2c0-.41,0-.83,0-1.28,0-.23,0-.46,0-.7a1.53,1.53,0,0,1,.2-.75c.66-.81,1.45-1.52,2.26-2.38l1.26-1.3c.23-.23.42-.45.69-.68a1.24,1.24,0,0,1,1-.21,2,2,0,0,1,.85.61l.73.72c.5.48,1,1,1.51,1.48l1.56,1.53a2.78,2.78,0,0,1,.4.43,1.18,1.18,0,0,1,.19.6c0,.38,0,.76,0,1.14,0,1.52,0,3,0,4.44v.14h-.13l-3.57,0h-.13V164c0-1,0-2,0-3a.84.84,0,0,0-.72-.87c-.41,0-.89,0-1.29,0a.88.88,0,0,0-.77.69c0,.36,0,.78,0,1.14v2.13h-.08l-2.87,0-.75,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.3,
    y: 181.92,
    width: 124.98,
    height: 22.73,
    rx: 9.59,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.7,204.66l.72-.06a11.36,11.36,0,0,0,2.06-.4,10.1,10.1,0,0,0,3-1.58,9.45,9.45,0,0,0,2.85-3.62,9.17,9.17,0,0,0,.75-2.65,25.24,25.24,0,0,0,.09-3.06A20.94,20.94,0,0,0,534,190a9.45,9.45,0,0,0-7.55-7.71,25.71,25.71,0,0,0-4.34-.17h-4.62l-98.62.07a9.34,9.34,0,0,0-9.32,8.57c-.08,1.14,0,2.33,0,3.49a10.87,10.87,0,0,0,.35,3.38,9.38,9.38,0,0,0,3.87,5.29,9,9,0,0,0,3,1.3,13.8,13.8,0,0,0,3.29.24h19.43l44.34.05,29.89.08,8.13,0,2.11,0c.48,0,.72,0,.72,0l-.72,0-2.11,0-8.13,0-29.89.07-44.34.05H420.08a14.43,14.43,0,0,1-3.39-.25,9.52,9.52,0,0,1-3.18-1.35,9.9,9.9,0,0,1-4.06-5.56,11.54,11.54,0,0,1-.38-3.5c0-1.17,0-2.32,0-3.53a9.84,9.84,0,0,1,9.79-9l98.62.07h4.62a26.77,26.77,0,0,1,4.4.18,9.75,9.75,0,0,1,6.47,4.54,9.65,9.65,0,0,1,1.26,3.43,20.41,20.41,0,0,1,.13,3.37,24,24,0,0,1-.11,3.09,9.64,9.64,0,0,1-3.72,6.35,9.27,9.27,0,0,1-5.15,1.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.63,192.75s0-.37-.22-1a4,4,0,0,0-1.51-2.16,3.91,3.91,0,1,0,0,6.28,4,4,0,0,0,1.51-2.16c.18-.61.18-1,.22-1s0,.09,0,.26a3,3,0,0,1-.07.77,4.08,4.08,0,0,1-1.49,2.37,4.24,4.24,0,0,1-4.06.67,4.32,4.32,0,0,1,0-8.14,4.27,4.27,0,0,1,4.06.66,4.12,4.12,0,0,1,1.49,2.38,2.92,2.92,0,0,1,.07.76Q526.66,192.75,526.63,192.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.9,199.85a15.91,15.91,0,0,1-3.69-4,8.06,8.06,0,0,1,2,1.84A8.26,8.26,0,0,1,528.9,199.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.18,191H424v-.58h5.13V191h-2.23v5.76h-.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.66,194.6h-4a1.76,1.76,0,0,0,1.87,1.66,1.87,1.87,0,0,0,1.46-.63l.36.42A2.52,2.52,0,0,1,429,194.4a2.32,2.32,0,1,1,4.64,0S433.66,194.52,433.66,194.6Zm-4-.48h3.38a1.69,1.69,0,0,0-3.38,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.89,196.78l-1.52-2-1.52,2h-.72l1.88-2.45L434.22,192h.72l1.43,1.87,1.44-1.87h.7l-1.79,2.32,1.9,2.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.2,196.49a1.51,1.51,0,0,1-1,.34,1.26,1.26,0,0,1-1.39-1.39v-2.88H439V192h.85v-1h.64v1h1.45v.55h-1.45v2.84a.76.76,0,0,0,.83.87,1.06,1.06,0,0,0,.7-.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 223.36,
    width: 27.36,
    height: 27.36,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,226.31c0,.13-9.15.23-20.43.23s-20.43-.1-20.43-.23,9.15-.23,20.43-.23S494.56,226.18,494.56,226.31Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.14,234.69c0,.13-16.44.24-36.72.24s-36.72-.11-36.72-.24,16.44-.23,36.72-.23S527.14,234.57,527.14,234.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.28,240.68c0,.13-16.25.24-36.29.24s-36.29-.11-36.29-.24,16.24-.23,36.29-.23S526.28,240.55,526.28,240.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.55,246.4c0,.12-9.59.23-21.42.23s-21.43-.11-21.43-.23,9.59-.24,21.43-.24S496.55,246.27,496.55,246.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 268.94,
    width: 27.36,
    height: 27.36,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,271.89c0,.12-9.15.23-20.43.23s-20.43-.11-20.43-.23,9.15-.24,20.43-.24S494.56,271.76,494.56,271.89Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.14,280.27c0,.13-16.44.23-36.72.23s-36.72-.1-36.72-.23,16.44-.23,36.72-.23S527.14,280.14,527.14,280.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.28,286.26c0,.13-16.25.23-36.29.23s-36.29-.1-36.29-.23S469.94,286,490,286,526.28,286.13,526.28,286.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.55,292c0,.13-9.59.24-21.42.24s-21.43-.11-21.43-.24,9.59-.23,21.43-.23S496.55,291.84,496.55,292Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 314.52,
    width: 27.36,
    height: 27.36,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,317.46c0,.13-9.15.24-20.43.24s-20.43-.11-20.43-.24,9.15-.23,20.43-.23S494.56,317.33,494.56,317.46Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.14,325.85c0,.13-16.44.23-36.72.23s-36.72-.1-36.72-.23,16.44-.23,36.72-.23S527.14,325.72,527.14,325.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.28,331.84c0,.13-16.25.23-36.29.23s-36.29-.1-36.29-.23,16.24-.23,36.29-.23S526.28,331.71,526.28,331.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.55,337.55c0,.13-9.59.23-21.42.23s-21.43-.1-21.43-.23,9.59-.23,21.43-.23S496.55,337.42,496.55,337.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 360.1,
    width: 27.36,
    height: 27.36,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,363c0,.13-9.15.23-20.43.23s-20.43-.1-20.43-.23,9.15-.23,20.43-.23S494.56,362.91,494.56,363Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.14,371.43c0,.12-16.44.23-36.72.23s-36.72-.11-36.72-.23,16.44-.24,36.72-.24S527.14,371.3,527.14,371.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.28,377.42c0,.12-16.25.23-36.29.23s-36.29-.11-36.29-.23,16.24-.24,36.29-.24S526.28,377.29,526.28,377.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.55,383.13c0,.13-9.59.23-21.42.23s-21.43-.1-21.43-.23,9.59-.23,21.43-.23S496.55,383,496.55,383.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 405.68,
    width: 27.36,
    height: 27.36,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.56,408.62c0,.13-9.15.23-20.43.23s-20.43-.1-20.43-.23,9.15-.23,20.43-.23S494.56,408.49,494.56,408.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.14,417c0,.13-16.44.24-36.72.24s-36.72-.11-36.72-.24,16.44-.23,36.72-.23S527.14,416.88,527.14,417Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.28,423c0,.13-16.25.24-36.29.24s-36.29-.11-36.29-.24,16.24-.23,36.29-.23S526.28,422.86,526.28,423Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.55,428.71c0,.12-9.59.23-21.42.23s-21.43-.11-21.43-.23,9.59-.24,21.43-.24S496.55,428.58,496.55,428.71Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 360.1,
    width: 27.36,
    height: 27.36
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 414.58,
    y: 268.94,
    width: 27.36,
    height: 27.36
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.02,
    y: 49.24,
    width: 148.64,
    height: 60.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.65,109.61s0-.37,0-1.08,0-1.76,0-3.13c0-2.76,0-6.8,0-12,0-10.42-.05-25.49-.09-44.14l.16.16L329,49.47h0l.23-.23c0,21.14,0,41.55,0,60.37l-.22-.23,106.57.11,30.91.06,8.28,0,2.14,0h0l-2.12,0-8.23,0-30.86.06L329,109.84h-.23v-.23c0-18.82,0-39.23,0-60.37V49H329l148.62.07h.17v.17c0,18.69-.07,33.8-.09,44.24,0,5.2,0,9.24,0,12,0,1.36,0,2.4,0,3.1S477.65,109.61,477.65,109.61Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.16,57.38c0-.13,33.23-.24,74.2-.24s74.21.11,74.21.24-33.22.23-74.21.23S329.16,57.51,329.16,57.38Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 334.31,
    cy: 53.74,
    r: 1.08,
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.08,53.74A1.08,1.08,0,1,1,338,52.66,1.07,1.07,0,0,1,339.08,53.74Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.73,53.74a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,342.73,53.74Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 341.65,
    y: 67.19,
    width: 35.9,
    height: 35.9,
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.65,
    y: 67.19,
    width: 35.9,
    height: 35.9,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,76.81c0,.13-18.47.24-41.26.24s-41.26-.11-41.26-.24,18.47-.23,41.26-.23S467.37,76.68,467.37,76.81Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,84.13c0,.13-18.47.23-41.26.23s-41.26-.1-41.26-.23,18.47-.24,41.26-.24S467.37,84,467.37,84.13Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,91.44a2.24,2.24,0,0,1-.54,0l-1.55,0-5.69.08-18.78.06-18.78-.06-5.7-.08-1.54,0a2.24,2.24,0,0,1-.54,0,2.24,2.24,0,0,1,.54,0l1.54,0,5.7-.08,18.78-.07,18.78.07,5.69.08,1.55,0A2.24,2.24,0,0,1,438,91.44Z",
    style: {
      fill: "#1EB445"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-16"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "566.49 438.96 571.62 457.93 554.95 459.45 551.45 441.39 566.49 438.96",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.47,457.91a11.64,11.64,0,0,0,2.44-.09c1.5-.12,3.57-.35,5.85-.64l5.83-.78A12.93,12.93,0,0,0,571,456a12.58,12.58,0,0,0-2.44.09c-1.5.13-3.57.36-5.85.65l-5.83.78A12.52,12.52,0,0,0,554.47,457.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "571.62 457.93 554.95 459.45 554.68 458.06 571.14 455.97 571.61 457.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M563.34,457.09a67,67,0,0,0-1.59-7.27,74,74,0,0,0-2-7.18,68.3,68.3,0,0,0,1.58,7.27A72.22,72.22,0,0,0,563.34,457.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.39,457.78a8,8,0,0,1,0-3.52,7,7,0,0,1,1.82-3.3,6.85,6.85,0,0,1,4.15-1.91,7.15,7.15,0,0,1,4.47,1,7.92,7.92,0,0,1,2.6,2.76,10,10,0,0,1,1.05,3.39.76.76,0,0,0,0-.26,4.11,4.11,0,0,0,0-.72,7.69,7.69,0,0,0-3.44-5.47,7.36,7.36,0,0,0-4.7-1.1,6.88,6.88,0,0,0-6.2,5.54,6.71,6.71,0,0,0,0,2.66,3.64,3.64,0,0,0,.21.69C555.34,457.71,555.37,457.79,555.39,457.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.65,433.87l1.11,16.85s-16.77,5.57-16.87,8.7l32.78.24L514,433.33Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M508.85,449a1.33,1.33,0,0,1,1,1.5,1.29,1.29,0,0,1-1.48,1,1.41,1.41,0,0,1-1-1.59A1.32,1.32,0,0,1,509,449",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M514.67,459.66,514.6,457l-31.65.87a2.26,2.26,0,0,0-1.22,1.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M498.23,450.57c0,.16.81.21,1.61.7s1.25,1.15,1.39,1.08-.12-1-1.1-1.56S498.19,450.43,498.23,450.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.84,452.1c0,.15.67.41,1.23,1.07s.74,1.37.9,1.35.23-.92-.48-1.72S494.84,452,494.84,452.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493,456.27c.15,0,.34-.78-.09-1.64s-1.2-1.19-1.26-1.06.41.59.76,1.31S492.85,456.26,493,456.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.4,446.7c.07.15.8-.1,1.71-.06s1.61.3,1.69.16-.61-.69-1.68-.72S498.32,446.58,498.4,446.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.24,443.3a3,3,0,0,0,1.64-.06,7,7,0,0,0,1.7-.58,6.84,6.84,0,0,0,.93-.53,2,2,0,0,0,.48-.4.7.7,0,0,0,.05-.85.86.86,0,0,0-.72-.34,2.16,2.16,0,0,0-.61.1,6,6,0,0,0-1,.38,5.84,5.84,0,0,0-1.48,1c-.74.73-1,1.33-.92,1.36s.42-.46,1.18-1.07a6.45,6.45,0,0,1,1.44-.86,5.36,5.36,0,0,1,.93-.32c.35-.1.64-.12.73,0s0,.08,0,.18a1.54,1.54,0,0,1-.35.29,8.84,8.84,0,0,1-.85.52,8.45,8.45,0,0,1-1.57.66A10.37,10.37,0,0,0,498.24,443.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.45,443.52a2.56,2.56,0,0,0,.39-1.59,5.3,5.3,0,0,0-.28-1.79,5.42,5.42,0,0,0-.45-1,1.36,1.36,0,0,0-1.07-.79.76.76,0,0,0-.67.47,2.25,2.25,0,0,0-.15.61,3.72,3.72,0,0,0,0,1.11,3.91,3.91,0,0,0,.75,1.67c.67.83,1.34,1,1.35.95s-.51-.38-1-1.18a3.79,3.79,0,0,1-.56-1.53,3.29,3.29,0,0,1,0-.94c0-.35.16-.64.29-.61s.45.25.59.52a6,6,0,0,1,.44.88,5.75,5.75,0,0,1,.36,1.63C498.52,442.9,498.37,443.5,498.45,443.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.65 287.46 547.58 287.08 571.71 445.57 550.99 448.2 524.43 317.89 516.48 448.66 516.46 449.05 494.05 448.66 497.65 287.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.36,300.3a8.57,8.57,0,0,1-1.12,0h-3.06l-10.66-.09.24-.23c0,3.14,0,6.64,0,10.35l-.09-.19,1.89,1.73,5.52,5.09h-.33l7.45-6.52-.07.15c0-3.09.08-5.63.1-7.48,0-.85,0-1.54.06-2.09a6.36,6.36,0,0,1,0-.76,4.19,4.19,0,0,1,0,.69c0,.53,0,1.2.06,2,0,1.88.06,4.46.1,7.6v.09l-.07.06-7.38,6.59-.17.15-.17-.15-5.54-5.08-1.88-1.73-.08-.07v-.12c0-3.71,0-7.21,0-10.35v-.24h.23l10.8.32,3,.12A6.85,6.85,0,0,1,520.36,300.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.86,299.62s-.36.07-1,.15l-2.72.33-9.56,1.08.21-.25c.38,3.07.82,6.55,1.29,10.27L532,311l2.15,1.72c1.84,1.46,3.61,2.89,5.3,4.24l-.35,0,5.87-7.29,0,.15c-.33-3.05-.6-5.58-.8-7.42-.08-.85-.15-1.54-.2-2.09s-.06-.75,0-.76a3.44,3.44,0,0,1,.13.67c.08.53.18,1.2.3,2,.26,1.87.61,4.43,1,7.52v.09l-.05.07-5.81,7.34-.15.2-.2-.16-5.31-4.22-2.15-1.72-.09-.07v-.1c-.44-3.73-.86-7.22-1.22-10.28l0-.23.23,0,9.72-.86,2.68-.21A4.89,4.89,0,0,1,543.86,299.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.31,323.67a11.64,11.64,0,0,1,2.1-1.4c1.33-.8,3.21-1.84,5.33-2.9s4.09-1.94,5.53-2.52a10.92,10.92,0,0,1,2.38-.83,14,14,0,0,1-2.23,1.16c-1.39.67-3.33,1.6-5.44,2.65s-4,2.05-5.4,2.76A12.55,12.55,0,0,1,513.31,323.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514,327.52a27.57,27.57,0,0,0,4.92-3.57,27.89,27.89,0,0,0,3.64-4.86,13.32,13.32,0,0,1-8.56,8.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.86,373.31c.09,0,.45,1.14,1.55,2.74a13,13,0,0,0,13.11,5.53c1.91-.33,3-.89,3-.8a2.28,2.28,0,0,1-.75.43,10.79,10.79,0,0,1-2.22.73,12.67,12.67,0,0,1-13.49-5.69,10.91,10.91,0,0,1-1-2.1A2.5,2.5,0,0,1,499.86,373.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.14,372a18.16,18.16,0,0,1,2,.51,24.22,24.22,0,0,0,4.89.67c3.88.14,7-.45,7-.28a6.89,6.89,0,0,1-2,.49,26,26,0,0,1-5,.31,18.81,18.81,0,0,1-5-.83A5.6,5.6,0,0,1,503.14,372Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.27,372.91a34.46,34.46,0,0,0,6.88,3.81,34.84,34.84,0,0,0,7.7,1.62,7.08,7.08,0,0,1-2.34.07A20,20,0,0,1,542,374.5,7.31,7.31,0,0,1,540.27,372.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.64,372.71c0-.15,2.06.1,4.54-.11s4.46-.76,4.5-.61a13.7,13.7,0,0,1-9,.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.73,319a76.08,76.08,0,0,0,8.08,2,75,75,0,0,0,8.31.59,8.39,8.39,0,0,1-2.45.29,30,30,0,0,1-5.94-.37A31.23,31.23,0,0,1,527,320,9,9,0,0,1,524.73,319Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.09,313.62c.14,0,.26.45.25,1s-.13,1-.28,1-.25-.45-.24-1S526,313.62,526.09,313.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.07,309.62c.15,0,.27.44.27,1s-.1,1-.25,1-.26-.45-.27-1S525.93,309.62,526.07,309.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,305.62c.14,0,.28.44.29,1s-.08,1-.23,1-.27-.44-.29-1S525.83,305.62,526,305.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.78,301.62c.14,0,.28.44.31,1s-.06,1-.2,1-.29-.43-.32-1S525.64,301.63,525.78,301.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5,297.63c.14,0,.29.43.33,1s0,1-.18,1-.29-.43-.34-1S525.36,297.64,525.5,297.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.13,293.65c.14,0,.3.42.36,1s0,1-.16,1-.31-.42-.36-1S525,293.66,525.13,293.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.29,444.48c.14,0,.35.39.45.93s.09,1-.06,1-.34-.39-.45-.93S553.15,444.51,553.29,444.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.51,440.56c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S552.37,440.59,552.51,440.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.72,436.64c.14,0,.35.38.45.93s.09,1,0,1-.35-.39-.46-.93S551.58,436.66,551.72,436.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.94,432.71c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S550.8,432.74,550.94,432.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.15,428.79c.14,0,.35.39.46.93s.08,1-.06,1-.35-.38-.46-.93S550,428.82,550.15,428.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.37,424.87c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S549.23,424.9,549.37,424.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.58,421c.15,0,.35.39.46.93s.08,1-.06,1-.35-.39-.45-.93S548.44,421,548.58,421Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.8,417c.14,0,.34.38.45.92s.08,1-.06,1-.34-.39-.45-.93S547.66,417.05,547.8,417Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547,413.1c.14,0,.34.39.45.93s.08,1-.06,1-.35-.38-.45-.93S546.87,413.13,547,413.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.23,409.18c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S546.09,409.21,546.23,409.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.45,405.26c.14,0,.34.39.45.93s.08,1-.06,1-.35-.39-.45-.93S545.3,405.29,545.45,405.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.66,401.34c.14,0,.34.38.45.93s.08,1-.06,1-.34-.39-.45-.93S544.52,401.36,544.66,401.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.88,397.41c.14,0,.34.39.45.93s.08,1-.06,1-.34-.38-.45-.92S543.74,397.44,543.88,397.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.09,393.49c.14,0,.35.39.45.93s.09,1-.06,1-.34-.39-.45-.93S543,393.52,543.09,393.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.31,389.57c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S542.17,389.6,542.31,389.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.52,385.65c.14,0,.35.38.45.93s.09,1-.06,1-.34-.39-.45-.93S541.38,385.68,541.52,385.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.74,381.72c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S540.6,381.75,540.74,381.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540,377.8c.14,0,.35.39.45.93s.09,1,0,1-.35-.38-.46-.93S539.81,377.83,540,377.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.17,373.88c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S539,373.91,539.17,373.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M538.38,370c.15,0,.35.39.46.93s.08,1-.06,1-.35-.39-.46-.93S538.24,370,538.38,370Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.6,366c.14,0,.34.38.45.93s.08,1-.06,1-.34-.39-.45-.93S537.46,366.06,537.6,366Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.81,362.11c.15,0,.35.39.46.93s.08,1-.06,1-.35-.38-.45-.93S536.67,362.14,536.81,362.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,358.19c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S535.89,358.22,536,358.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.25,354.27c.14,0,.34.39.45.93s.08,1-.06,1-.35-.39-.45-.93S535.1,354.3,535.25,354.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.46,350.35c.14,0,.34.38.45.93s.08,1-.06,1-.34-.39-.45-.93S534.32,350.37,534.46,350.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.68,346.42c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S533.54,346.45,533.68,346.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.89,342.5c.14,0,.34.39.45.93s.08,1-.06,1-.34-.38-.45-.93S532.75,342.53,532.89,342.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.11,338.58c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S532,338.61,532.11,338.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.32,334.66c.14,0,.35.39.45.93s.09,1-.06,1-.34-.39-.45-.93S531.18,334.69,531.32,334.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.54,330.73c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S530.4,330.76,530.54,330.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.75,326.81c.14,0,.35.39.45.93s.09,1-.05,1-.35-.38-.46-.93S529.61,326.84,529.75,326.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529,322.89c.14,0,.34.39.45.93s.08,1-.06,1-.34-.39-.45-.93S528.83,322.92,529,322.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.29,319.48c.14,0,.32.28.4.67s0,.75-.11.78-.32-.27-.4-.67S528.15,319.51,528.29,319.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.72,214.64s-5.85-8.76-6-8.84h0s-5.28-8.88-7-8.88-1.12,1.8.69,5a12.64,12.64,0,0,1,1.75,4.53l-4.33,2.62s-2.9-1.12-3,1.57a18.78,18.78,0,0,0,.5,3.66c.18,1,.61,2,1.52,1.63a1.15,1.15,0,0,0,.77-1.09c.06-1.59-.24-2.18,0-2.18s3.12,8.37,3.12,8.37Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.92,207.76a9,9,0,0,0-1.39-.83,2.88,2.88,0,0,0-1.58-.24,1.41,1.41,0,0,0-.88.46,1.43,1.43,0,0,0-.16,1.33,4,4,0,0,0,.71,1.2",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.89,206a7.55,7.55,0,0,0-1.31-.78,2.77,2.77,0,0,0-1.5-.23,1.33,1.33,0,0,0-.83.44,1.35,1.35,0,0,0-.16,1.25,11.13,11.13,0,0,0,1.35,1.74",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.68,209.69l8.44,18.06-9.31,9.51L452,223.8s-2.59.52-3.65-1.2c-1.19-1.93-2.74-7.49-2.74-7.49Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.65,209.19c-.16.07-.59-1.06-1.4-2.2s-1.89-1.69-1.8-1.84a3.32,3.32,0,0,1,2.22,1.53A4.35,4.35,0,0,1,451.65,209.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.28,209.27c0-.05.2-.33.73-.52a2.74,2.74,0,0,1,2.17.19,3.68,3.68,0,0,1,1.43,1.61c.23.48.32.8.26.84s-.27-.23-.58-.65a4.57,4.57,0,0,0-1.36-1.34,2.92,2.92,0,0,0-1.83-.29C442.62,209.19,442.32,209.34,442.28,209.27Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.42,206.72a2.61,2.61,0,0,1,2.31.8,3,3,0,0,1,1.21,2.12c-.14.07-.62-.9-1.55-1.73S445.4,206.88,445.42,206.72Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.35,210.62c.14,0,.17.57.52,1.1s.8.8.76.94-.76.05-1.21-.67S443.21,210.57,443.35,210.62Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.7,214.28s.29-5.38-1-6.6-5,0-5,0",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.13,205.15a13.17,13.17,0,0,1,2.32,2.79,12.62,12.62,0,0,1,1.91,3.09,13,13,0,0,1-2.33-2.79A12.52,12.52,0,0,1,453.13,205.15Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.1,210.06c-.14-.72-.31-1.56-.56-2.54a7.68,7.68,0,0,0-1.07-2.37,11.79,11.79,0,0,0-2.06-2.48,1,1,0,0,1,.44-1.85c.9,0,3.15,1.58,4.69,4.39s2.45-2.15,2.81-4,1.75-7.33,2.39-7.66c1-.48,1.63.44,1.23,2.24s-1.24,7.25-.28,7.39,2.67-9.06,2.67-9.06,0-2,1.17-1.89c2,.24-.54,9.88-.8,10.8-.19.63.85.83,1,.14s1.51-9.22,3.56-9c1.57.17-2,7.95-1.32,9.87s2.13-6.18,3.62-6c.56.09,1,.23-.52,4.76-.73,2.2-3.53,12.51-3.53,12.51l1.61,8.45-12.83,3.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.87,164.3l.13,42-18,.86L509.44,197s-6.41,1.28-8.06-4.68c-1.06-3.8-.79-33.17-.79-33.17Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.21,162.09c2.84.81,3.46,5.45,3.46,5.45l4.46,9.85c2.27-1.78,5.32-1.68,5.9,2.31.41,2.89-3.17,3.47-3.17,3.47,2.08,3.55,3.5,6.42,6.54,9.8,3.29,3.66,5.13,4,8.7,4.08H528s1.92-6.24,5.49-21.87c4-17.34-16.55-15.11-20.35-19.53C507,148.44,489.26,159.52,498.21,162.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.14,176.81c3.33-2.23,3.63-8.47,1.69-12.22a12.05,12.05,0,0,0-10.24-6.37,4.93,4.93,0,0,1-1.67-.18,4.61,4.61,0,0,1-1.8-1.71c-3-3.86-5.88-7.65-11.42-7.65a6.32,6.32,0,0,0-3.48.86,5.49,5.49,0,0,0-2.09,2.77,12.21,12.21,0,0,0-3.24-1.17,4,4,0,0,0-3.25.8,2.45,2.45,0,0,0-.51,3.11,3.92,3.92,0,0,0-3.92,3.27c-.3,1.85,2.35,3.14,2.62,3.29,0,0-1.45,3,2,4.86a4.17,4.17,0,0,0,3.42-.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,180.86c.15,0,.2,1.41.58,3.08s.94,3,.8,3a5.8,5.8,0,0,1-1.31-2.92A5.87,5.87,0,0,1,520,180.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.79,178.79a13.33,13.33,0,0,1,.65,3,13.8,13.8,0,0,1,.47,3,11.11,11.11,0,0,1-1.12-6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.54,171.85a3.24,3.24,0,0,1,1.37,1,9.68,9.68,0,0,1,2.15,3.42,18.45,18.45,0,0,1,1,3.89,5.07,5.07,0,0,1,.11,1.65,5.12,5.12,0,0,1-.47-1.58,29.08,29.08,0,0,0-1.09-3.78,11.69,11.69,0,0,0-1.93-3.35C512,172.3,511.49,171.92,511.54,171.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509,167.13a17,17,0,0,0,.28,3.89,18.08,18.08,0,0,0,1.58,3.56,5.62,5.62,0,0,1-2.09-3.44A5.53,5.53,0,0,1,509,167.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.55,177.63c-.07-.13.37-.51,1-.85s1.18-.53,1.25-.4-.37.5-1,.85S530.62,177.76,530.55,177.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.83,173.14c.15,0,.42.74.93,1.58s1.06,1.44,1,1.56-.85-.36-1.41-1.29S521.69,173.16,521.83,173.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.15,171.7c.14,0,.53.9,1.21,1.92s1.39,1.74,1.3,1.86-1-.47-1.73-1.58A3.35,3.35,0,0,1,519.15,171.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.83,154.09s.06-.09.2-.23a3.86,3.86,0,0,1,.69-.56,6.41,6.41,0,0,1,3.11-1,8.23,8.23,0,0,1,4.68,1.15,11.09,11.09,0,0,1,4,4.36A18.7,18.7,0,0,1,520,161.9l-.36-.15a9.41,9.41,0,0,1,7.62-.4,8.6,8.6,0,0,1,2,1.07,3.31,3.31,0,0,1,.6.54,16.06,16.06,0,0,0-2.68-1.32,9.43,9.43,0,0,0-7.29.55l-.27.14-.08-.3A18.9,18.9,0,0,0,518,158.1a10.81,10.81,0,0,0-3.76-4.2,8.14,8.14,0,0,0-4.42-1.2,6.77,6.77,0,0,0-3,.77C506.17,153.84,505.86,154.13,505.83,154.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.34,156.38a1.59,1.59,0,0,0-1.18,1.75,1.78,1.78,0,0,0,.95,1.23,2.62,2.62,0,0,0,1.93.21,6,6,0,0,0,2.09-1.07,23,23,0,0,1,2.24-1.57,9.77,9.77,0,0,1,2.81-1,11.35,11.35,0,0,1,5.67.42,14.44,14.44,0,0,1,4.08,2.19,16.5,16.5,0,0,1,2.3,2.1,4.22,4.22,0,0,1,.71.9c-.07.07-1.12-1.19-3.22-2.7a14.79,14.79,0,0,0-4-2,11.11,11.11,0,0,0-5.42-.37,9.22,9.22,0,0,0-2.66.93,23.22,23.22,0,0,0-2.21,1.51,6.28,6.28,0,0,1-2.27,1.1,3,3,0,0,1-2.21-.31,2.07,2.07,0,0,1-1.06-1.51,1.79,1.79,0,0,1,.43-1.33C495.84,156.23,496.38,156.37,496.34,156.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.21,208.41l22,39.41a11.15,11.15,0,0,1-1.7,10.48l.46-.66a9.43,9.43,0,0,1-7.32,3.5h-.42a9.42,9.42,0,0,1-8.63-5.66l-5.17-7.85Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.46,205.59c4.33-2.21,8.6-2.71,13.26-2.85,5.42-.16,13.07-.92,18.92-.29,0,0,17.82-.55,17.9,13.26l-2.36,53L550,291.44l-53.39,1.61.38-26.8c-.66-13.95.75-33.7.75-33.7-.82-7.49-4.93-10.87-5.51-15.74C491.72,212.5,494.6,207.56,498.46,205.59Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.51,269.49c.06-.08,1.21,1,3.39,2.11a20.16,20.16,0,0,0,18.43.32c2.21-1.07,3.4-2.07,3.46-2a4.17,4.17,0,0,1-.81.72,17.15,17.15,0,0,1-2.49,1.59,19.38,19.38,0,0,1-18.77-.33,17.34,17.34,0,0,1-2.43-1.68A4.23,4.23,0,0,1,513.51,269.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.54,215.71a1.76,1.76,0,0,1,0,.52c0,.41,0,.9,0,1.5,0,1.39-.06,3.25-.11,5.52-.11,4.66-.31,11.1-.61,18.2s-.65,13.54-1,18.19c-.17,2.33-.31,4.21-.44,5.51l-.15,1.49a1.88,1.88,0,0,1-.09.52,2.21,2.21,0,0,1,0-.53q0-.6.06-1.5c.07-1.38.16-3.24.27-5.51.21-4.72.5-11.12.82-18.19s.57-13.46.77-18.19c.11-2.27.2-4.13.26-5.51,0-.6.07-1.1.1-1.5A2,2,0,0,1,548.54,215.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.73,220.29s2,5.93,2.38,6.73c0,0,5,14.41,6.61,24.14l-15.94-28.78C552.64,222.4,559.52,220.35,559.73,220.29Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.88,218.55a11,11,0,0,1,1,1.48c.64,1,1.48,2.41,2.5,4.08,2.1,3.45,5.19,8.11,8.29,13.46,1.54,2.68,2.84,5.33,4,7.77a14.24,14.24,0,0,1,1.48,7,10.49,10.49,0,0,1-1.41,4.6,8,8,0,0,1-.77,1.07c-.2.22-.31.33-.33.32s.4-.5.92-1.49a10.83,10.83,0,0,0,1.23-4.52,14.2,14.2,0,0,0-1.56-6.75c-1.13-2.41-2.44-5-4-7.71-3.08-5.33-6.12-10-8.14-13.53-1-1.75-1.83-3.18-2.36-4.17A11.68,11.68,0,0,1,551.88,218.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.68,233.27,466,225.19l7.8,13.5s10.81-15,15.72-23.82c4.52-8.11,10.36-10.29,13.19-10.88a1.25,1.25,0,0,1,1.49,1.37L500,234.58c-.53,1.52-9.45,14.45-14.44,20.95-8.31,10.86-20.57,3.91-23.93-3.69C458.93,245.81,454.77,236.65,453.68,233.27Z",
    style: {
      fill: "#1EB445"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.28,250.89a6.91,6.91,0,0,1-.11-1.95,23.86,23.86,0,0,1,.46-4.69,12.78,12.78,0,0,1,1.76-4.38,4.41,4.41,0,0,1,1.31-1.46c.07.06-.42.62-1,1.65a15.1,15.1,0,0,0-1.57,4.3,36.9,36.9,0,0,0-.6,4.6A8.43,8.43,0,0,1,470.28,250.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.66,244.85a3.25,3.25,0,0,1,.11-1.68,7.78,7.78,0,0,1,2-3.55,5.09,5.09,0,0,1,3.64-1.81c1.1,0,1.62.59,1.57.62a5.34,5.34,0,0,0-1.57-.25,5.13,5.13,0,0,0-3.26,1.8,8.64,8.64,0,0,0-2,3.29A16.2,16.2,0,0,1,466.66,244.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.54,207.6a1.54,1.54,0,0,1,.36.27,8.23,8.23,0,0,1,.94.91,11.66,11.66,0,0,1,2.32,4.18,16,16,0,0,1,.58,7,15.47,15.47,0,0,1-1.06,4.08,43,43,0,0,1-2,4,156.16,156.16,0,0,1-8.54,13.18c-1.17,1.63-2.14,2.94-2.84,3.82-.34.44-.63.78-.82,1a2,2,0,0,1-.31.33,11.11,11.11,0,0,1,1-1.45c.68-1,1.6-2.31,2.7-3.91,2.25-3.32,5.36-7.91,8.38-13.22a43.42,43.42,0,0,0,2-4,15.19,15.19,0,0,0,1.06-3.94,16.42,16.42,0,0,0-.46-6.89,12.16,12.16,0,0,0-2.13-4.15,9.72,9.72,0,0,0-.85-1C503.63,207.74,503.53,207.62,503.54,207.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M517.33,271.87c-3.94-1.8-7.05-5.92-7.17-10.09a4.16,4.16,0,0,1,1-3.12c1.16-1.15,3.13-.94,4.58-.17,2.39,1.25,3.95,3.6,5.63,5.71s3.8,4.19,6.49,4.45a17.44,17.44,0,0,0,3.45-.26,5.84,5.84,0,0,1,3.39.41,2.55,2.55,0,0,1,1.4,2.86s-4.72,2.94-9.64,2.59A27.81,27.81,0,0,1,517.33,271.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M503.51,285.23a9,9,0,0,1,1.54.36c1,.28,2.41.63,4.18,1s3.91.75,6.29,1.05a76.92,76.92,0,0,0,7.78.47,75,75,0,0,0,7.79-.43c2.38-.28,4.51-.63,6.29-1s3.2-.72,4.18-1a10.7,10.7,0,0,1,1.55-.36,8.46,8.46,0,0,1-1.49.55c-1,.33-2.39.74-4.16,1.16a60.22,60.22,0,0,1-6.32,1.13,62.33,62.33,0,0,1-15.68-.05,58.91,58.91,0,0,1-6.31-1.16c-1.77-.43-3.19-.84-4.16-1.18A10.26,10.26,0,0,1,503.51,285.23Z",
    style: {
      fill: "#263238"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.7c515882e7bfd2ef8207855e8380656f.svg";
export { ForwardRef as ReactComponent };